import React from "react";
import CryptoJS from "crypto-js";
import API from "@aws-amplify/api";
import { ClipLoader } from "react-spinners";
import { css } from "react-emotion";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import PropTypes from "prop-types";
import $ from "jquery";
import ReactTable from "react-table";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import "assets/scss/responsive.css";
import SweetAlert from "react-bootstrap-sweetalert";
import CreateAudiences from "./CreateAudiences";
import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "components/CustomButtons/Button.jsx";
import Close from "@material-ui/icons/Close";
import Edit from "@material-ui/icons/Edit";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import notificationsStyle from "assets/jss/material-dashboard-pro-react/views/notificationsStyle.jsx";
// import Select from "react-select/lib/Creatable";
import Demo2 from "./SegmentQueryBuilder/demo";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import TagsInput from "react-tagsinput";
// import ChipInput from "material-ui-chip-input";
import Chip from "@material-ui/core/Chip";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import FormControl from "@material-ui/core/FormControl";
// import Select from '@material-ui/core/Select';
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormHelperText from "@material-ui/core/FormHelperText";
import Select from "react-select";
import InputAdornment from "@material-ui/core/InputAdornment";
import Email from "@material-ui/icons/Email";
import CardHeader from "components/Card/CardHeader.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import Assignment from "@material-ui/icons/Assignment";
import Snackbar from "components/Snackbar/Snackbar.jsx";
import Refresh from "@material-ui/icons/Refresh";
import Tooltip from "@material-ui/core/Tooltip";
import Creatable, { makeCreatableSelect } from "react-select/lib/Creatable";
import CreatableSelect from "react-select/lib/Creatable";
import Datetime from "react-datetime";
import Today from "@material-ui/icons/Today";
import TextField from "@material-ui/core/TextField";
import UpdateIcon from "@material-ui/icons/Update";
import Switch from "@material-ui/core/Switch";
import CronBuilder from "react-cron-builder";
import "react-cron-builder/dist/bundle.css";
import moment from "moment";
import { StartForm } from "../AudienceBuilder/components/startForm/startForm";
import { handleInitalAudienceEdit } from "../AudienceBuilder/util/caching/handleInitalAudienceEdit";
import {
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Table,
} from "@material-ui/core";
import Icon from "@material-ui/core/Icon";
import Slide from "@material-ui/core/Slide";
import { spendgoOffercode } from "../../util/client-specific/spendgo-offercode";

function Transition(props) {
  return <Slide direction="down" {...props} />;
}
const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
  text-align: center;
  margin-top: 10px;
`;

let checkedArr = [];
let demoDuplicate = [];
//let subFields = ['sub01', 'sub02', 'sub03', 'sub04','sub05','sub06','sub07','sub08','sub09']
let subFields = {
  sub01: "",
  sub02: "",
  sub03: "",
  sub04: "",
  sub05: "",
  sub06: "",
  sub07: "",
  sub08: "",
};
const subFieldOptions = [
  //{ value: 'ocean', label: 'Ocean', color: '#00B8D9', isFixed: true },
  { value: "ci.cac_cust_name_first", label: "First Name" },
  { value: "ci.cac_cust_name_first", label: "Last Name" },
  { value: "ci.cac_cust_name_first", label: "Red" },
];
let newArray = {
  value: "Personal Info",
  label: "Personal Info",
  type: "select",
  data: [
    { value: "cac_name_first", label: "First Name", end: "true" },
    { value: "cac_name_last", label: "Last Name", end: "true" },
    { value: "cac_ind1_email", label: "Email", end: "true" },
    { value: "cac_addr_zip", label: "Zip", end: "true" },
    { value: "cac_addr_city", label: "City", end: "true" },
    { value: "cac_addr_full", label: "Street", end: "true" },
    { value: "cac_addr_state", label: "State", end: "true" },
  ],
};
let FB = {
  value: "Facebook",
  label: "Facebook",
  type: "select",
  data: [
    { value: "Facebook", label: "Facebook", end: "true" },
    { value: "Email", label: "Email", end: "true" },
    //{ value: "Preclub", label: "PreClub", end: "true" },
    { value: "Direct Mail", label: "Direct Mail", end: "true" },
  ],
};

let DM = {
  value: "DM",
  label: "DM",
  type: "select",
  data: [
    { value: "cac_name_first", label: "First Name", end: "true" },
    { value: "cac_name_last", label: "Last Name", end: "true" },
    { value: "cac_ind1_email", label: "Email", end: "true" },
    { value: "cac_addr_zip", label: "Zip", end: "true" },
    { value: "cac_addr_city", label: "City", end: "true" },
    { value: "cac_addr_full", label: "Street", end: "true" },
    { value: "cac_addr_state", label: "State", end: "true" },
  ],
};

let EM = {
  value: "EM",
  label: "EM",
  type: "select",
  data: [
    { value: "cac_name_first", label: "First Name", end: "true" },
    { value: "cac_name_last", label: "Last Name", end: "true" },
    { value: "cac_ind1_email", label: "Email", end: "true" },
    { value: "cac_addr_zip", label: "Zip", end: "true" },
    { value: "cac_addr_city", label: "City", end: "true" },
    { value: "cac_addr_full", label: "Street", end: "true" },
    { value: "cac_addr_state", label: "State", end: "true" },
  ],
};

demoDuplicate.push(FB);
let subList = [];
let multiSubList = [];

var labelsMap = new Map();

/*const options = [
  { value: "Eclub", label: "Eclub"},
  { value: "PreClub", label: "PreClub"}
];*/
const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
    overflowX: "auto",
  },
  table: {
    minWidth: 700,
  },
  row: {
    "&:nth-of-type(odd)": {
      backgroundColor: theme.palette.background.default,
    },
  },
});
let apiName = process.env.REACT_APP_AMPLIFY_API;
var yesterday = Datetime.moment().subtract(1, "day");
let dateValid = function(current) {
  return current.isAfter(yesterday);
};
class Audience extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showABStartForm: false,
      recurringValue: "",
      recurring: false,
      allTemplates: [],
      exportDisable: false,
      copyDescription: "",
      copyTitle: "",
      copyAudienceModal: false,
      selectedTypeInputfields: [],
      dropDownSelection: [],
      automationDropSelection: [],
      automationDropSelectionModified: [], // Created to filter automationDropSelectionArray and append the Values to the Program Dropdown
      channelTypesDropSelection: [],
      campaignDropdown: [],
      automationConfirmationModal: false,
      automationSnack: false,
      exportgroupLeveltoggleSegment: [],
      exportruleLeveltoggleSegment: [],
      exportbSqlSelectionArrSegment: [],
      exportsegmentName: [],
      exportaSqlSelectionArrSegment: [],
      exportCustomerType: "",
      exportTemplate: [],
      displayExportCount: {},
      selectedRefreshObject: {},
      loadingInitalSpinner: "false",
      exportSelectionCount: "",
      nonexportSelectionCount: "",
      totalexportSelectionCount: "",
      noteexportSelectionCount: "",
      selectedTemplate: "",
      checked: [],
      checkedValues: [],
      itemData: [],
      loading: true,
      redirect: false,
      createAudience: false,
      id: "",
      open: false,
      message: "",
      // checked: false,
      alert: null,
      classicModal: false,
      deploymentModal: false,
      deploymentName: "",
      selectedChannel: "",
      selectedChannelType: "",
      selectedCampaign: "",
      campaignModal: false,
      campaignName: "",
      campaignDescription: "",
      campaignEpochEnds: 0,
      campaignEpochStarts: 0,
      automationTimestamp: 0,
      emailModal: false,
      fileFormat: "",
      search: "",
      audienceId: "",
      query: "",
      email: JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("email"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ),
      error: false,
      channeltypeerror: false,
      registerEmailState: "",
      registerPasswordState: "",
      selectAll: false,
      title: "",
      showExportContent: "",
      listTitle: "",
      audienceTitle: "",
      listDesc: " ",
      fields: {},
      errors: {},
      exInputFieldserror: false,
      color: "success",
      showCountsAlert: null,
      automationSwitchStatus: true,
      clientSeedListSwitchStatus: false,
      localStorageClientId: "",
      offerCodeModal: false,
      offerCodeValue: "",
      offerCodeDurationValue: "",

      // Make Lists Feature Changes
      selectedAudienceChannelId: "",
      selectChannelOptionsDropdown: [],
      preclubFlag: false,

      // DIS-ACQ specific changes

      acquisitionChannelId: [
        { id: "d977fc2b-2352-473b-9a54-b80765f0400c" },
        { id: "79b91604-9f03-428a-9026-9be77ca9a687" },
        { id: "2c77a7b6-60e9-4c75-819e-e93b60d47b82" }
      ],
      customerChannelId: [
        { id: "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91" },
        { id: "1905c46e-6f48-4ed8-b2a9-35dbbf3bae91" },
        { id: "d1606aea-0c0d-4fba-83e8-a124f414a953" },
        { id: "a8f39ffb-24c5-432a-9bcd-e5d0166a320e" },
        { id: "3b3e90db-f06b-4ba4-9fbb-769637647ab0" },
        { id: "f786cb0f-eecc-4b87-adef-34eb20f3f766" },
        { id: "0417f699-bdd9-473d-873f-499e1c86efac" },
        { id: "g786cb0f-eecc-4b87-adef-34eb20f3f766" },
        { id: "88adbfaa-0fc0-49af-a745-d97cb1b4bda7" },
        { id: "1d337d2d-e23a-445a-bda6-2405dbb79dcc" },
        { id: "25c7cb9a-a192-46f5-b32d-49e8d52afea8" },
        { id: "92ec41c7-6724-4891-bc17-24981a3261dd" },
        { id: "8905c46e-6f48-4ed8-b2a9-35dbbf3bae91" },
        { id: "3c8a9cf7-a0b2-4845-8436-d598181e6d78" },
        { id: "c2a842ba-36cc-46b7-8fa4-3a361708b34b" },
        { id: "33bc71b1-4495-43f0-ab64-17ed38270e04" }
      ],
      combinedChannelId: [{ id: "2f524d19-d3d2-498f-bd73-8d68737e809d" }],
      showOrHideClientSeedListSwitch: "none",
      friendlyFromDropdownSelection: [
        {
          value: "Bristol Seafood + Steak + Social",
          label: "Bristol Seafood + Steak + Social",
        },
        {
          value: "Bristol Seafood Grill",
          label: "Bristol Seafood Grill",
        },
        {
          value: "Devon Seafood + Steak",
          label: "Devon Seafood + Steak",
        },
        {
          value: "Devon Seafood Grill",
          label: "Devon Seafood Grill",
        },
        {
          value: "Seafood Grill",
          label: "Seafood Grill"
        },
      ],
      selectedFriendlyFromOption: "",
      friendlyFromOptionError: false,
    };

    this.hideAlert = this.hideAlert.bind(this);
    this.successDelete = this.successDelete.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.routeChange = this.routeChange.bind(this);
    this.deleteAudience = this.deleteAudience.bind(this);
    this.warningWithConfirmMessage = this.warningWithConfirmMessage.bind(this);
    this.getItems = this.getItems.bind(this);
    // this.onCheckbox = this.onCheckbox.bind(this);
    this.exportColumns = this.exportColumns.bind(this);
    this.handleTags = this.handleTags.bind(this);
    this.updateDynamoDB = this.updateDynamoDB.bind(this);
    this.handleOfferCodeChange = this.handleOfferCodeChange.bind(this);
    this.checkAll = this.checkAll.bind(this);
    checkedArr = [];
  }
  download(url) {
    setTimeout(function() {
      window.location.href = url;
    }, 5000);
    // let iframe = document.createElement('iframe');
    // iframe.id = "hiddenDownloader";
    // iframe.style.visibility = 'hidden';
    // iframe.src = url;
    // document.body.appendChild(iframe).click();
    // $('<iframe>', { id:'idown', src:url }).hide().appendTo('body').click();
  }
  handleChangeCreatable(subs, newValue, actionMeta) {
    if (actionMeta["action"] == "create-option") {
      subFields[subs] = newValue == null ? "" : "'" + newValue["value"] + "'";
    } else {
      subFields[subs] = newValue == null ? "" : newValue["value"];
    }
  }

  handleOfferCodeChange = (event) => {
    this.setState({ offerCodeValue: event.target.value });
  };

  handleDurationChange = (event) => {
    this.setState({ offerCodeDurationValue: event.target.value });
  };

  offerCodeModalSaveButton() {
    if (this.state.offerCodeValue == "") {
      let err = {};
      err["offerCodeValue"] = "Please enter the offer code";
      this.setState({ errors: err });
      setTimeout(
        function() {
          this.setState({
            errors: (err["offerCodeValue"] = ""),
          });
        }.bind(this),
        3000
      );
    } else {
      if (this.state.offerCodeDurationValue == "") {
        let err = {};
        err["offerCodeDurationValue"] = "Please enter the offer code duration";
        this.setState({ errors: err });
        setTimeout(
          function() {
            this.setState({
              errors: (err["offerCodeDurationValue"] = ""),
            });
          }.bind(this),
          3000
        );
      }
    }
    if (
      this.state.offerCodeValue !== "" &&
      this.state.offerCodeDurationValue !== ""
    ) {
      this.setState({ offerCodeModal: false });
    }
  }

  togglePreclubFlagStatus(event) {
    this.setState({ preclubFlag: event });
  }

  deploymentDate(event) {
    let tt = Date.parse(Datetime.moment(event.target.value).format()) / 1000;
    this.setState({ automationTimestamp: tt });
  }
  campaignStartDate(event) {
    let tt = Date.parse(Datetime.moment(event.target.value).format()) / 1000;
    this.setState({ campaignEpochStarts: tt });
  }
  campaignEndDate(event) {
    let tt = Date.parse(Datetime.moment(event.target.value).format()) / 1000;
    this.setState({ campaignEpochEnds: tt });
  }
  saveCampaign() {
    if (this.state.campaignName == "") {
      let err = {};
      err["campaignName"] = "Please enter Campaign Name";
      this.setState({ errors: err });
      setTimeout(
        function() {
          this.setState({
            errors: (err["campaignName"] = ""),
          });
          // this.props.history.push("/audiences/viewAudiences");
        }.bind(this),
        3000
      );
    } else if (this.state.campaignEpochStarts == 0) {
      /*else if(this.state.campaignDescription == '') {
      let err = {}
      err["campaignDescription"] = "Please enter Campaign Description";
      this.setState({ errors: err });
      setTimeout(
        function() {
          this.setState({
            errors: err['campaignDescription'] = ''
          });
          // this.props.history.push("/audiences/viewAudiences");
        }.bind(this),
        3000
      );
    }*/
      let err = {};
      err["campaignStartDate"] = "Please select a valid start date";
      this.setState({ errors: err });
      setTimeout(
        function() {
          this.setState({
            errors: (err["campaignStartDate"] = ""),
          });
          // this.props.history.push("/audiences/viewAudiences");
        }.bind(this),
        3000
      );
    } else if (this.state.campaignEpochEnds == 0) {
      let err = {};
      err["campaignEndDate"] = "Please select a valid end date";
      this.setState({ errors: err });
      setTimeout(
        function() {
          this.setState({
            errors: (err["campaignEndDate"] = ""),
          });
          // this.props.history.push("/audiences/viewAudiences");
        }.bind(this),
        3000
      );
    } else {
      let minimumTimeStamp = Math.round(new Date().getTime() / 1000) + 300;
      if (
        this.state.campaignEpochEnds <= minimumTimeStamp ||
        this.state.campaignEpochStarts <= minimumTimeStamp ||
        this.state.campaignEpochStarts >= this.state.campaignEpochEnds
      ) {
        let err = {};
        err["campaignEndDate"] = "Please select a valid date and time";
        this.setState({ errors: err });
        setTimeout(
          function() {
            this.setState({
              errors: (err["campaignEndDate"] = ""),
            });
            // this.props.history.push("/audiences/viewAudiences");
          }.bind(this),
          3000
        );
      } else {
        // Created at date to be stored in the DB inorder to sort the Campaign List based on the created at date
        const createdAt = moment(new Date()).unix();
        //
        const uuidv4 = require("uuid/v4");
        let campaignuuid = uuidv4();
        let campaignPostObj = {
          id: campaignuuid,
          name: this.state.campaignName,
          description:
            this.state.campaignDescription == ""
              ? " "
              : this.state.campaignDescription,
          clientId: JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("clientId"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ),
          preclub: this.state.preclubFlag,
          scheduledEnd: this.state.campaignEpochEnds,
          scheduledStart: this.state.campaignEpochStarts,
          campaignCreatedAt: createdAt,
        };
        fetch(
          "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/campaigns",
          {
            method: "post",
            body: JSON.stringify(campaignPostObj),
          }
        )
          .then((res) => res.json())
          .then((result) => {
            this.getCampaigns();
            this.setState({ campaignModal: false });
          });
      }
    }
  }
  handleCronChange = (event) => {
    this.setState({ recurringValue: event });
  };
  getCampaigns() {
    fetch(
      "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/campaigns",
      {
        method: "get",
        headers: {
          clientId: JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("clientId"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ),
        },
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          // if ("Items" in result) {
          //   if (result["Items"].length > 0) {
          //     let allDynamoCampaigns = result["Items"];
          //     let tempCampaignDropdown = [];
          //     for (let eachCampaigns in allDynamoCampaigns) {
          //       let campaignOpt = {};
          //       campaignOpt["label"] =
          //         allDynamoCampaigns[eachCampaigns]["name"];
          //       campaignOpt["value"] = allDynamoCampaigns[eachCampaigns]["id"];
          //       tempCampaignDropdown.push(campaignOpt);
          //     }
          //     this.setState({ campaignDropdown: tempCampaignDropdown });
          //   }
          // }
          // Reworked the above code to sort the campaign list (Sorted based on the created date)
          if ("Items" in result) {
            if (result["Items"].length > 0) {
              let allDynamoCampaigns = result["Items"];
              let tempCampaignDropdown = [];
              for (let eachCampaigns in allDynamoCampaigns) {
                let campaignOpt1 = {};
                if (
                  allDynamoCampaigns[eachCampaigns]["campaignCreatedAt"] !==
                  undefined
                ) {
                  campaignOpt1["label"] =
                    allDynamoCampaigns[eachCampaigns]["name"] +
                    " - Created Date :  " +
                    new Date(
                      allDynamoCampaigns[eachCampaigns]["campaignCreatedAt"] *
                        1000
                    ).toLocaleDateString();
                  campaignOpt1["value"] =
                    allDynamoCampaigns[eachCampaigns]["id"];
                  campaignOpt1["campaignCreatedAt"] =
                    allDynamoCampaigns[eachCampaigns]["campaignCreatedAt"];

                  tempCampaignDropdown.push(campaignOpt1);
                }
              }

              tempCampaignDropdown.sort(
                (a, b) => b.campaignCreatedAt - a.campaignCreatedAt
              );

              for (let eachCampaigns in allDynamoCampaigns) {
                let campaignOpt = {};
                if (
                  allDynamoCampaigns[eachCampaigns]["campaignCreatedAt"] ===
                  undefined
                ) {
                  campaignOpt["label"] =
                    allDynamoCampaigns[eachCampaigns]["name"];
                  campaignOpt["value"] =
                    allDynamoCampaigns[eachCampaigns]["id"];
                  tempCampaignDropdown.push(campaignOpt);
                }
              }
              this.setState({ campaignDropdown: tempCampaignDropdown });
            }
          }
        },
        (error) => {}
      );
  }
  handlecampaignChange = (event) => {
    this.setState({ selectedCampaign: event.value });
  };
  /*handleInputChangeCreatable = (inputValue, actionMeta) => {
  };*/
  checkAll = (event) => {
    var flag = event.target.checked;

    let newChecked = [];
    if (flag) {
      this.setState({ selectAll: true });
      demoDuplicate.map((list, idx) => {
        subList = list.data;
        const filteredArray = subList.filter((str, i) =>
          str.label.toUpperCase().startsWith(this.state.search.toUpperCase())
        );
        filteredArray.map((listData, idx) => {
          if (listData.end == "true") {
            newChecked.push(listData.value);
            labelsMap.set(listData.value, listData.label);
          } else {
            multiSubList = listData.data;
            if (multiSubList != undefined) {
              multiSubList.map((multiListData, idx) => {
                if (
                  multiListData.end == "true" &&
                  idx == 0 &&
                  multiListData.value.indexOf("+++") != -1
                ) {
                  var res = multiListData.value.split("+++");
                  newChecked.push(res[0]);
                  labelsMap.set(res[0], listData.label);
                }
              });
            }
          }
        });
      });
    } else {
      this.setState({ selectAll: false });
      newChecked = [];
      labelsMap = new Map();
    }
    this.setState({
      checked: newChecked,
    });
  };
  updateDynamoDB(audienceid) {
    let pathAud = "/audiences";
    let headersAud = {
      headers: {
        id: audienceid,
      },
    };
    API.get(apiName, pathAud, headersAud).then((response) => {
      let allStringCount = "<br/>";
      let customerct = "";
      let directmailct = "";
      let emailct = "";
      let fbct = "";
      let totct = "";

      let columns = this.state.checked;

      if ("finalCount" in response[0]) {
        customerct = response[0]["finalCount"];
      }
      if ("dmCount" in response[0]) {
        directmailct = response[0]["dmCount"];
      }
      if ("emailCount" in response[0]) {
        emailct = response[0]["emailCount"];
      }
      if ("fbCount" in response[0]) {
        fbct = response[0]["fbCount"];
      }
      if ("totCustomerCount" in response[0]) {
        totct = response[0]["totCustomerCount"];
      }

      let sendArray = [];
      for (let m in columns) {
        let innerObj = {};
        if (columns[m] == "Facebook") {
          innerObj[columns[m]] = fbct;
          sendArray.push(innerObj);
          allStringCount =
            allStringCount + "<b>" + columns[m] + "</b>: " + fbct + "<br/>";
        }
        if (columns[m] == "Direct Mail") {
          innerObj[columns[m]] = directmailct;
          sendArray.push(innerObj);
          allStringCount =
            allStringCount +
            "<b>" +
            columns[m] +
            "</b>: " +
            directmailct +
            "<br/>";
        }
        if (columns[m] == "Email") {
          innerObj[columns[m]] = emailct;
          sendArray.push(innerObj);
          allStringCount =
            allStringCount + "<b>" + columns[m] + "</b>: " + emailct + "<br/>";
        }
      }
      this.setState({ showExportContent: false });
      // s is the string "1+2+3+testing"
      let myInitCount = {
        headers: {},
        body: {
          tempExport: "export",
          //query: this.state.query,
          clientId: JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("clientId"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ),
          countDetails: allStringCount,
          columns: columns,
          emailId: "djoshi@cogensia.com",
          givenName: JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("given_name"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ),
          lastName: JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("family_name"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ),
          sendArray: sendArray,
          title: this.state.title,
        },
      };
      API.post(apiName, "/counts", myInitCount)
        .then((response) => {
          if (response.success !== undefined && response.status !== undefined) {
          } else if (response.status === undefined) {
          }
        })
        .catch((error) => {});
    });
  }

  getSegmentCondition() {
    let selectedRule = "";
    let selectedOptionValue = "";
    let selectedResult = [];
    let groupLeveltoggle = this.state.exportgroupLeveltoggleSegment;
    let ruleLeveltoggle = this.state.exportruleLeveltoggleSegment;
    let count = 0;
    let sqlAndOrOperator = "";
    this.state.exportbSqlSelectionArrSegment.map((resultData, index) => {
      let segment = "";
      if (this.state.exportsegmentName[index] != undefined) {
        segment = this.state.exportsegmentName[index];
      }
      selectedRule += `WHEN `;
      resultData.map((options, key) => {
        let length = options.length;
        if (
          "value" in options[length - 2] &&
          options[length - 2].value.includes("+++")
        ) {
          options[length - 2].value = options[length - 2].value.split("+++")[0];
        }
        if (
          options[length - 1].value === "BETWEEN" ||
          options[length - 1].value === "NOT BETWEEN"
        ) {
          selectedRule += "(";
        }
        if (
          options[length - 1].value === "cardinality(array_intersect(" ||
          options[length - 1].value === "cardinality(array_except("
        ) {
          selectedRule +=
            "(" +
            options[length - 1].value +
            options[length - 2].value +
            ", array";
        } else {
          selectedRule +=
            "(" + options[length - 2].value + " " + options[length - 1].value;
        }
        let data = this.state.exportaSqlSelectionArrSegment[index][key];
        if (data.length > 0) {
          data.map((result, resultKey) => {
            count = count + 1;
            sqlAndOrOperator = "";
            if (
              options[length - 1].value == "IN" ||
              options[length - 1].value == "NOT IN"
            ) {
              if (resultKey == 0) {
                selectedRule += `(`;
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                if (typeof num == "string") {
                  selectedRule += ` '${result.value}', `;
                } else {
                  selectedRule += ` ${result.value}, `;
                }
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                selectedRule += `))`;
                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                }
              } else {
                let num = result.value;
                if (typeof num == "string") {
                  selectedRule += ` '${result.value}', `;
                } else {
                  selectedRule += ` ${result.value}, `;
                }
              }
            } else if (
              options[length - 1].value == "cardinality(array_intersect("
            ) {
              if (resultKey == 0) {
                selectedRule += `[`;
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                let aggarray = [];
                selectedRule += ` '${result.value}', `;
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                selectedRule += `])) > 0 AND ${JSON.parse(
                  CryptoJS.AES.decrypt(
                    localStorage.getItem("globalFilter"),
                    process.env.REACT_APP_PASS
                  ).toString(CryptoJS.enc.Utf8)
                )})`;

                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                }
              } else {
                let num = result.value;
                selectedRule += ` '${result.value}', `;
              }
            } else if (
              options[length - 1].value == "cardinality(array_except("
            ) {
              if (resultKey == 0) {
                selectedRule += `[`;
              }
              if (resultKey == data.length - 1) {
                let num = result.value;
                let aggarray = [];
                selectedRule += ` '${result.value}', `;
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                selectedRule += `])) > 0 AND ${JSON.parse(
                  CryptoJS.AES.decrypt(
                    localStorage.getItem("globalFilter"),
                    process.env.REACT_APP_PASS
                  ).toString(CryptoJS.enc.Utf8)
                )})`;

                if (
                  ruleLeveltoggle.length > 0 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                }
              } else {
                let num = result.value;
                selectedRule += ` '${result.value}', `;
              }
            } else if (options[length - 1].value == "= ") {
              selectedRule += ` ${result.value} AND ${JSON.parse(
                CryptoJS.AES.decrypt(
                  localStorage.getItem("globalFilter"),
                  process.env.REACT_APP_PASS
                ).toString(CryptoJS.enc.Utf8)
              )})`;
            } else {
              let num = result.value;
              if (
                options[length - 1].value === "BETWEEN" ||
                options[length - 1].value === "NOT BETWEEN"
              ) {
                selectedRule += ` ${result.value}) AND ${JSON.parse(
                  CryptoJS.AES.decrypt(
                    localStorage.getItem("globalFilter"),
                    process.env.REACT_APP_PASS
                  ).toString(CryptoJS.enc.Utf8)
                )}),`;
              } else if (typeof num == "string") {
                selectedRule += ` '${result.value}'), `;
              } else {
                selectedRule += ` ${result.value}), `;
              }
              selectedRule = selectedRule.replace(/,(\s+)?$/, "");
              if (
                ruleLeveltoggle.length > 0 &&
                key !== resultData.length - 1 &&
                ruleLeveltoggle[index] !== undefined &&
                ruleLeveltoggle[index][key] !== undefined
              ) {
                sqlAndOrOperator = ruleLeveltoggle[index][key];
                selectedRule += ` ${sqlAndOrOperator} `;
              }
            }
          });
        }
      });
      selectedRule = selectedRule.replace(/,(\s+)?$/, "");
      selectedRule += ` THEN `;
      selectedRule += ` '${segment}' `;
      // selectedRule += `)`;
      // sqlAndOrOperator = "";
      // if (
      //   groupLeveltoggle.length > 0 &&
      //   this.props.cust_tillSqlSelectionArrSegment.length - 1 != index &&
      //   groupLeveltoggle[0] != undefined &&
      //   groupLeveltoggle[0][index] != undefined
      // ) {
      //   sqlAndOrOperator = groupLeveltoggle[0][index];
      //   selectedRule += ` ${sqlAndOrOperator} `;
      // }

      // var position=selectedRule.indexOf(")(")+1
      // while(position > 0){
      //   if (position > 0){
      //       selectedRule=[selectedRule.slice(0, position), " AND ", selectedRule.slice(position)].join('');
      //   }
      //   position=selectedRule.indexOf(")(")+1
      // }

      selectedRule = selectedRule.replace(/,(\s+)?$/, "");
    });
    this.exportQuery(this.state.audienceId, selectedRule);
  }

  exportQuery(audienceid, sRule) {
    const uuidv4 = require("uuid/v4");

    let filterExportTemplateBck = this.state.exportTemplate;
    let filterExportTemplate = filterExportTemplateBck.filter((obj) => {
      return obj.name === this.state.selectedTemplate;
    });
    let selectionFields = "";
    let fte = filterExportTemplate[0]["fields"];

    //selectionFields = selectionFields + "('" + this.state.exportCustomerType + "')" +' as ' + 'audience_type' + ',';
    //selectionFields = (sRule == '' ? (selectionFields + ' null as audience_segment ,') : (selectionFields + " case " + sRule + " else 'Remainder' end segment ,"));
    let expQuery_1 = "";

    let cmpClientIdObject = {
      "8c001fde-3728-48dc-9950-b8480ca9fbee": "33", // Baja Fresh
      "1857ba2f-010f-4f49-bcd1-f9fd09db2799": "22", // Primanti Bro's
      "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f": "13", // Bad Daddy's
      "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534": "30", // Lou Malnatis
      "f0d3b19b-a564-43e9-85dd-bd95f8b13f97": "31", // Data Delivers Cafe / Data Delivers
      "52b86a20-91ae-457b-a6c7-f7708431b645": "1", // HouliHan's
      "19357b26-ddae-4b3a-9e95-b5879f1e9572": "32", // Uncle Julios
      "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9": "9", // SeaFood Grill
      "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406": "1", // HouliHan's NE
      "74d71e90-46e0-45b8-9b6e-a96883e85d54": "4", // Morton's
      "7abec586-17b8-4174-993d-e3d86648ed60": "1", // HouliHan's CEN
      "2b7ed789-e2d0-45c0-a45f-49e27d736a7b": "29", // J.Gilbert's
      "c566b59a-7y94-4ag0-96cf-88av8084d1s3": "31", // Cogensia Cafe
      "687c8c2a-0986-4147-bf38-0d5bac9f7530": "36", // Eegee's
      "b44cc84d-73b5-4457-bb48-68e9626d08e1": "39", // Viva Chicken
      "535a90f3-b463-4d5a-9a83-39c522589a6c": "41", // Mambo
      "ec0df8ce-c87e-4746-a00e-d2c9ee4d7534": "42", //Lous
      "e722fa14-9dbd-11ee-8c90-0242ac120002": "43", // ToC
      "31a73952-d1bf-4647-af62-204b1f56596c": "44", // Pollo Tropical
      "4d288e9e-9254-4513-bb54-072b9f8fc882": "45", // Flag Stop
      "d1522630-2b9d-424e-a399-7ab3f7be274f": "", // Lennys
      "7203dd51-f88b-4a4b-877c-92326d027915": "", // Planet Smoothie
      "83da098f-2fc7-4b98-8455-c08f9aceb4ed": "", // Taco Time
      "cf6144d2-bb68-43b6-9876-dbf620b57c21": "", // Sweet Frog
      "37f97bea-f005-4be1-8e41-286ad79a7f3a": "48", // Bahamabucks
      "ec5a162e-5e87-4819-93bd-70bbf3b5f096": "47", // Brio Bravo
      "24ab940a-50d2-41fd-b3b2-c67ca6cb0304": "", // New Demo Client
      "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac": "49", // Bertucci
      "874b6c6a-83ff-480b-b615-1972538813ba": "50", // Bravo
      "b76e7818-deb1-4526-93a7-b398df3ea357": "27", // Goodtimes
      "e08840c5-c7d0-48c7-9c24-124b4cd80735": "51", // Ruby Tuesdays
      "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e": "52", // Firebirds
      "0bc2a383-9ae0-4e9e-9652-0fb762ba6119": "55", // Wow Car Wash
      "7bf99619-30a3-47a3-b1de-d72b4f7f99a7": "53", // Better Buzz
      "a4dda78e-7678-4aaf-9bef-60a229085fc8": "54", // Smoothie King
    };

    let custIdToBeSuppressed = "";
    if (
      this.state.localStorageClientId === "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534"
    ) {
      custIdToBeSuppressed = JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("suppressionCustId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      );
    }

    if (this.state.selectedTemplate == "Email") {
      for (let eachSub in subFields) {
        if (subFields[eachSub] != "") {
          fte[fte.findIndex((obj) => obj.output == eachSub)].input =
            subFields[eachSub];
        }
      }
      fte[fte.findIndex((obj) => obj.order == 12)].input =
        "('" + this.state.exportCustomerType.toLocaleLowerCase() + "')";
      fte[fte.findIndex((obj) => obj.order == 11)].input =
        sRule == "" ? "null" : " case " + sRule + " else 'remainder' end ";
      fte[fte.findIndex((obj) => obj.order == 22)].input =
        sRule == "" ? "null" : " case " + sRule + " else 'remainder' end ";

      fte = fte.sort((a, b) => (a.order > b.order ? 1 : -1));
      for (let eachField in fte) {
        selectionFields =
          selectionFields +
          fte[eachField]["input"] +
          " as " +
          fte[eachField]["output"] +
          ",";
      }
      if (this.state.query.includes("li.")) {
        expQuery_1 =
          " FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".cust_analytic ca LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN ( SELECT * FROM ( SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept left join " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ).split("_")[0] +
          "_raw.lists_preclub li on li.cust_id = ca.cust_id " +
          "WHERE true AND " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("globalFilter"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          (this.state.query !== "" ? " AND " + this.state.query : "") +
          " AND oe.clean = true AND ca.global_control_flag is not null group by 1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22";
      } else {
        expQuery_1 =
          " FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".cust_analytic ca LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN ( SELECT * FROM ( SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept " +
          "WHERE true AND " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("globalFilter"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          (this.state.query !== "" ? " AND " + this.state.query : "") +
          " AND oe.clean = true AND ca.global_control_flag is not null group by 1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22";
      }
    }
    else if (this.state.selectedTemplate == "PreClub") {
      for (let eachSub in subFields) {
        if (subFields[eachSub] != "") {
          fte[fte.findIndex((obj) => obj.output == eachSub)].input =
            subFields[eachSub];
        }
      }
      fte[fte.findIndex((obj) => obj.order == 12)].input =
        "('" + this.state.exportCustomerType.toLocaleLowerCase() + "')";
      fte[fte.findIndex((obj) => obj.order == 11)].input =
        sRule == "" ? "null" : " case " + sRule + " else 'remainder' end ";
      fte[fte.findIndex((obj) => obj.order == 22)].input =
        sRule == "" ? "null" : " case " + sRule + " else 'remainder' end ";

      fte = fte.sort((a, b) => (a.order > b.order ? 1 : -1));
      for (let eachField in fte) {
        selectionFields =
          selectionFields +
          fte[eachField]["input"] +
          " as " +
          fte[eachField]["output"] +
          ",";
      }
      if (this.state.query.includes("li.")) {
        expQuery_1 =
          " FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".cust_analytic ca LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN ( SELECT * FROM ( SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept left join " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ).split("_")[0] +
          "_raw.lists_preclub li on li.cust_id = ca.cust_id LEFT JOIN " +
          ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
            cmpClientIdObject[
              JSON.parse(
                CryptoJS.AES.decrypt(
                  localStorage.getItem("clientId"),
                  process.env.REACT_APP_PASS
                ).toString(CryptoJS.enc.Utf8)
              )
            ]
          }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
            cmpClientIdObject[
              JSON.parse(
                CryptoJS.AES.decrypt(
                  localStorage.getItem("clientId"),
                  process.env.REACT_APP_PASS
                ).toString(CryptoJS.enc.Utf8)
              )
            ]
          }'),false ,true) or client_complaints is null))) ` +
          (this.state.query !== "" ? " AND " + this.state.query : "") +
          " AND oe.clean = true AND ca.global_control_flag is not null group by 1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22";
      } else {
        expQuery_1 =
          " FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".cust_analytic ca LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN ( SELECT * FROM ( SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
          ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
            cmpClientIdObject[
              JSON.parse(
                CryptoJS.AES.decrypt(
                  localStorage.getItem("clientId"),
                  process.env.REACT_APP_PASS
                ).toString(CryptoJS.enc.Utf8)
              )
            ]
          }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
            cmpClientIdObject[
              JSON.parse(
                CryptoJS.AES.decrypt(
                  localStorage.getItem("clientId"),
                  process.env.REACT_APP_PASS
                ).toString(CryptoJS.enc.Utf8)
              )
            ]
          }'),false ,true) or client_complaints is null))) ` +
          (this.state.query !== "" ? " AND " + this.state.query : "") +
          " AND oe.clean = true AND ca.global_control_flag is not null group by 1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22";
      }
    } else if (this.state.selectedTemplate == "Eclub") {
      for (let eachSub in subFields) {
        if (subFields[eachSub] != "") {
          fte[fte.findIndex((obj) => obj.output == eachSub)].input =
            subFields[eachSub];
        }
      }
      fte[fte.findIndex((obj) => obj.order == 12)].input =
        "('" + this.state.exportCustomerType.toLocaleLowerCase() + "')";
      fte[fte.findIndex((obj) => obj.order == 11)].input =
        sRule == "" ? "null" : " case " + sRule + " else 'remainder' end ";
      fte[fte.findIndex((obj) => obj.order == 22)].input =
        sRule == "" ? "null" : " case " + sRule + " else 'remainder' end ";

      fte = fte.sort((a, b) => (a.order > b.order ? 1 : -1));
      for (let eachField in fte) {
        selectionFields =
          selectionFields +
          fte[eachField]["input"] +
          " as " +
          fte[eachField]["output"] +
          ",";
      }

      if (this.state.query.includes("li.")) {
        expQuery_1 =
          " FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".cust_analytic ca LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN ( SELECT * FROM ( SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept left join " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ).split("_")[0] +
          "_raw.lists_preclub li on li.cust_id = ca.cust_id WHERE ( " +
          this.state.query +
          " ) AND ca.global_control_flag is not null group by 1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22";
      } else {
        expQuery_1 =
          " FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".cust_analytic ca LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN ( SELECT * FROM ( SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept WHERE ( " +
          this.state.query +
          " ) AND ca.global_control_flag is not null group by 1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22";
      }
    } else if (this.state.selectedTemplate == "Loyalty") {
      for (let eachSub in subFields) {
        if (subFields[eachSub] != "") {
          fte[fte.findIndex((obj) => obj.output == eachSub)].input =
            subFields[eachSub];
        }
      }
      fte[fte.findIndex((obj) => obj.order == 12)].input =
        "('" + this.state.exportCustomerType.toLocaleLowerCase() + "')";
      fte[fte.findIndex((obj) => obj.order == 11)].input =
        sRule == "" ? "null" : " case " + sRule + " else 'remainder' end ";
      fte[fte.findIndex((obj) => obj.order == 22)].input =
        sRule == "" ? "null" : " case " + sRule + " else 'remainder' end ";

      fte = fte.sort((a, b) => (a.order > b.order ? 1 : -1));
      for (let eachField in fte) {
        selectionFields =
          selectionFields +
          fte[eachField]["input"] +
          " as " +
          fte[eachField]["output"] +
          ",";
      }

      if (this.state.query.includes("li.")) {
        expQuery_1 =
          " FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".cust_analytic ca LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN ( SELECT * FROM ( SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept left join " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ).split("_")[0] +
          "_raw.lists_preclub li on li.cust_id = ca.cust_id WHERE ( " +
          this.state.query +
          ` ) AND ca.global_control_flag is not null AND ca.cust_id <> '${custIdToBeSuppressed}' group by 1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22`;
      } else {
        expQuery_1 =
          " FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".cust_analytic ca LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN ( SELECT * FROM ( SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept WHERE ( " +
          this.state.query +
          ` ) AND ca.global_control_flag is not null AND ca.cust_id <> '${custIdToBeSuppressed}' group by 1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22`;
      }
    } else if (this.state.selectedTemplate == "Facebook") {
      fte = fte.sort((a, b) => (a.order > b.order ? 1 : -1));
      for (let eachField in fte) {
        selectionFields =
          selectionFields +
          fte[eachField]["input"] +
          " as " +
          fte[eachField]["output"] +
          ",";
      }
      if (this.state.query.includes("li.")) {
        expQuery_1 =
          " FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".cust_analytic ca LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN ( SELECT * FROM ( SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".client_name_addr cn ON cn.cust_id = ca.cust_id WHERE ( " +
          this.state.query +
          " ) AND oe.clean = true AND ca.global_control_flag is not null group by 1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20";
      } else {
        expQuery_1 =
          " FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".cust_analytic ca LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN ( SELECT * FROM ( SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".client_name_addr cn ON cn.cust_id = ca.cust_id WHERE ( " +
          this.state.query +
          " ) AND oe.clean = true AND ca.global_control_flag is not null group by 1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20";
      }
    }

    if (
      this.state.localStorageClientId === "712cc8e9-3a79-4900-b122-ec9812e0f0ca"
    ) {
      expQuery_1 = expQuery_1.replaceAll(
        "geo.geo_active",
        "cast(geo.geo_active as boolean)"
      );
      expQuery_1 = expQuery_1.replaceAll(
        "if(lo.email_marketable=true,false,true)",
        "if(cast(lo.email_marketable as boolean)=true,false,true)"
      );
    }

    let listuuid = uuidv4();
    let copyOfSelectedTemplate = this.state.selectedTemplate;
    let listsPath = "/lists";
    //let sendBody = this.state.selectedRefreshObject;
    let sendBody = {};
    for (let eachSB in this.state.selectedRefreshObject) {
      if (eachSB == "id") {
        sendBody["audienceId"] = this.state.selectedRefreshObject[eachSB];
      } else if (eachSB == "createdAt") {
        sendBody["audienceDate"] = this.state.selectedRefreshObject[eachSB];
      } else if (eachSB == "title") {
        sendBody["audienceTitle"] = this.state.selectedRefreshObject[eachSB];
      } else if (eachSB == "description") {
        sendBody["audienceDescription"] = this.state.selectedRefreshObject[
          eachSB
        ];
      } else {
        sendBody[eachSB] = this.state.selectedRefreshObject[eachSB];
      }
    }
    sendBody["userId"] = JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem("userId"),
        process.env.REACT_APP_PASS
      ).toString(CryptoJS.enc.Utf8)
    );
    sendBody["id"] = listuuid;
    sendBody["title"] = this.state.listTitle;
    sendBody["description"] = this.state.listDesc;
    sendBody["createdAt"] = Math.round(new Date().getTime() / 1000);
    sendBody["exportQuery"] =
      "select " + selectionFields.slice(0, -1) + expQuery_1;
    sendBody["listType"] = this.state.selectedTemplate;
    var position = sendBody["filterRule"].indexOf(")(") + 1;
    while (position > 0) {
      if (position > 0) {
        sendBody["filterRule"] = [
          sendBody["filterRule"].slice(0, position),
          " AND ",
          sendBody["filterRule"].slice(position),
        ].join("");
      }
      position = sendBody["filterRule"].indexOf(")(") + 1;
    }
    let listsInit = {
      headers: {},
      body: sendBody,
    };
    API.post(apiName, listsPath, listsInit)
      .then((response) => {
        let finalexpQuery =
          "select " + selectionFields.slice(0, -1) + expQuery_1;
        let myInitCount = {
          headers: {},
          body: {
            sendgrid: "sendgrid",
            //query: this.state.query,
            query: finalexpQuery,
            clientId: JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("clientId"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ),
            emailId: "djoshi@cogensia.com",
            givenName: JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("given_name"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ),
            lastName: JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("family_name"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ),
            title: this.state.title,
            custDb: JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("custDb"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ),
            sourceBucket: JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("logoName"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            ).toLocaleLowerCase(),
            uuid: listuuid,
            selectedTemplate: copyOfSelectedTemplate,
          },
        };
        API.post(apiName, "/counts", myInitCount)
          .then((response) => {
            if (
              response.success !== undefined &&
              response.status !== undefined
            ) {
            } else if (response.status === undefined) {
            }
          })
          .catch((error) => {});
      })
      .catch((error) => {
        console.log(error.response);
      });
  }

  async exportColumns(id, modal, flag = 0) {
    // Changes for Make Lists Feature Starts
    let filteredObject = {};
    this.setState({
      selectChannelOptionsDropdown: [],
    });
    let allListFormatsFetched = this.state.dropDownSelection;
    filteredObject = allListFormatsFetched.filter(
      (item) => item.cid === this.state.selectedAudienceChannelId
    );
    // Added the below if block to force change the label to Guest Connect (To display on UI).
    if (filteredObject[0].label === "PreClub") {
      filteredObject[0].label = "Guest Connect";
    }
    this.setState({
      selectChannelOptionsDropdown: filteredObject,
    });
    // Changes for Make Lists Feature End
    var x = [];
    if (modal == "emailModal") {
      if (this.state.selectedTemplate == "") {
        this.setState({ error: true });
        setTimeout(
          function() {
            this.setState({
              error: false,
              // message: ""
            });
            // this.props.history.push("/audiences/viewAudiences");
          }.bind(this),
          3000
        );
        return false;
      } else {
        if (this.handleValidation()) {
          this.setState({ showExportContent: true });
          this.setState({ error: false });
          this.handleClose("classicModal");
          this.getSegmentCondition();
          this.setState({
            audienceId: id,
          });
          x[modal] = true;
          this.setState(x);
          return true;
        }
        setTimeout(
          function() {
            this.setState({
              errors: { listDesc: "", listTitle: "" },
              // message: ""
            });
            // this.props.history.push("/audiences/viewAudiences");
          }.bind(this),
          3000
        );
        return false;
      }
    }
    this.setState({
      audienceId: id,
    });
    x[modal] = true;
    this.setState(x);
    if (flag === 1) {
      let path = "/audiences";
      let myInit1 = {
        headers: {
          id: id,
        },
      };
      //Will fetch all the pre selected selections
      await API.get(apiName, path, myInit1).then((response) => {
        let ruleLeveltoggle = "";
        let groupLeveltoggle = "";
        let tillSqlSelectionArr = "";
        let afterSqlSelectionArr = "";
        if ("customerType" in response[0]) {
          this.setState({ exportCustomerType: response[0]["customerType"] });
        }
        if ("groupLeveltoggleSegment" in response[0]) {
          this.setState({
            exportgroupLeveltoggleSegment:
              response[0]["groupLeveltoggleSegment"],
          });
        }
        if ("ruleLeveltoggleSegment" in response[0]) {
          this.setState({
            exportruleLeveltoggleSegment: response[0]["ruleLeveltoggleSegment"],
          });
        }
        if ("bSqlSelectionArrSegment" in response[0]) {
          this.setState({
            exportbSqlSelectionArrSegment:
              response[0]["bSqlSelectionArrSegment"],
          });
        }
        if ("segmentName" in response[0]) {
          this.setState({ exportsegmentName: response[0]["segmentName"] });
        }
        if ("aSqlSelectionArrSegment" in response[0]) {
          this.setState({
            exportaSqlSelectionArrSegment:
              response[0]["aSqlSelectionArrSegment"],
          });
        }
        if ("groupLeveltoggle" in response[0]) {
          groupLeveltoggle = response[0]["groupLeveltoggle"];
        }
        if ("ruleLeveltoggle" in response[0]) {
          ruleLeveltoggle = response[0]["ruleLeveltoggle"];
        }
        if ("bSqlSelectionArr" in response[0]) {
          tillSqlSelectionArr = response[0]["bSqlSelectionArr"];
        }
        if ("aSqlSelectionArr" in response[0]) {
          afterSqlSelectionArr = response[0]["aSqlSelectionArr"];
        }
        this.setState({ title: response[0]["title"] });
        let selectedRule = "";
        let selectedOptionValue = "";
        let selectedResult = [];
        let count = 0;
        let sqlAndOrOperator = "";
        tillSqlSelectionArr.map((resultData, index) => {
          selectedRule += `(`;
          resultData.map((options, key) => {
            let length = options.length;
            if (options[length - 2].value.includes("+++")) {
              options[length - 2].value = options[length - 2].value.split(
                "+++"
              )[0];
            }
            if (
              options[length - 1].value === "BETWEEN" ||
              options[length - 1].value === "NOT BETWEEN"
            ) {
              selectedRule += "(";
            }
            if (
              options[length - 1].value === "cardinality(array_intersect(" ||
              options[length - 1].value === "cardinality(array_except("
            ) {
              selectedRule +=
                "(" +
                options[length - 1].value +
                options[length - 2].value +
                ", array";
            } else {
              selectedRule +=
                "(" +
                options[length - 2].value +
                " " +
                options[length - 1].value;
            }
            let data = afterSqlSelectionArr[index][key];
            if (data.length > 0) {
              data.map((result, resultKey) => {
                count = count + 1;
                sqlAndOrOperator = "";
                if (
                  options[length - 1].value == "IN" ||
                  options[length - 1].value == "NOT IN"
                ) {
                  if (resultKey == 0) {
                    selectedRule += `(`;
                  }
                  if (resultKey == data.length - 1) {
                    let num = result.value;
                    if (typeof num == "string") {
                      selectedRule += ` '${result.value}', `;
                    } else {
                      selectedRule += ` ${result.value}, `;
                    }
                    selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                    selectedRule += `) AND ${JSON.parse(
                      CryptoJS.AES.decrypt(
                        localStorage.getItem("globalFilter"),
                        process.env.REACT_APP_PASS
                      ).toString(CryptoJS.enc.Utf8)
                    )} )`;

                    if (
                      ruleLeveltoggle.length > 0 &&
                      ruleLeveltoggle[index] !== null &&
                      ruleLeveltoggle[index] !== undefined &&
                      ruleLeveltoggle[index][key] !== undefined
                    ) {
                      sqlAndOrOperator = ruleLeveltoggle[index][key];
                      selectedRule += ` ${sqlAndOrOperator} `;
                    }
                  } else {
                    let num = result.value;
                    if (typeof num == "string") {
                      selectedRule += ` '${result.value}', `;
                    } else {
                      selectedRule += ` ${result.value}, `;
                    }
                  }
                } else if (
                  options[length - 1].value == "cardinality(array_intersect("
                ) {
                  if (resultKey == 0) {
                    selectedRule += `[`;
                  }
                  if (resultKey == data.length - 1) {
                    let num = result.value;
                    let aggarray = [];
                    selectedRule += ` '${result.value}', `;
                    selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                    selectedRule += `])) > 0 AND ${JSON.parse(
                      CryptoJS.AES.decrypt(
                        localStorage.getItem("globalFilter"),
                        process.env.REACT_APP_PASS
                      ).toString(CryptoJS.enc.Utf8)
                    )})`;

                    if (
                      ruleLeveltoggle.length > 0 &&
                      ruleLeveltoggle[index] !== undefined &&
                      ruleLeveltoggle[index][key] !== undefined
                    ) {
                      sqlAndOrOperator = ruleLeveltoggle[index][key];
                      selectedRule += ` ${sqlAndOrOperator} `;
                    }
                  } else {
                    let num = result.value;
                    selectedRule += ` '${result.value}', `;
                  }
                } else if (
                  options[length - 1].value == "cardinality(array_except("
                ) {
                  if (resultKey == 0) {
                    selectedRule += `[`;
                  }
                  if (resultKey == data.length - 1) {
                    let num = result.value;
                    let aggarray = [];
                    selectedRule += ` '${result.value}', `;
                    selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                    selectedRule += `])) > 0 AND ${JSON.parse(
                      CryptoJS.AES.decrypt(
                        localStorage.getItem("globalFilter"),
                        process.env.REACT_APP_PASS
                      ).toString(CryptoJS.enc.Utf8)
                    )})`;

                    if (
                      ruleLeveltoggle.length > 0 &&
                      ruleLeveltoggle[index] !== undefined &&
                      ruleLeveltoggle[index][key] !== undefined
                    ) {
                      sqlAndOrOperator = ruleLeveltoggle[index][key];
                      selectedRule += ` ${sqlAndOrOperator} `;
                    }
                  } else {
                    let num = result.value;
                    selectedRule += ` '${result.value}', `;
                  }
                } else if (options[length - 1].value == "= ") {
                  selectedRule += ` ${result.value} AND ${JSON.parse(
                    CryptoJS.AES.decrypt(
                      localStorage.getItem("globalFilter"),
                      process.env.REACT_APP_PASS
                    ).toString(CryptoJS.enc.Utf8)
                  )})`;
                } else {
                  let num = result.value;
                  if (
                    options[length - 1].value === "BETWEEN" ||
                    options[length - 1].value === "NOT BETWEEN"
                  ) {
                    selectedRule += ` ${result.value}) AND ${JSON.parse(
                      CryptoJS.AES.decrypt(
                        localStorage.getItem("globalFilter"),
                        process.env.REACT_APP_PASS
                      ).toString(CryptoJS.enc.Utf8)
                    )} ),`;
                  } else if (typeof num == "string") {
                    selectedRule += ` '${result.value}' AND ${JSON.parse(
                      CryptoJS.AES.decrypt(
                        localStorage.getItem("globalFilter"),
                        process.env.REACT_APP_PASS
                      ).toString(CryptoJS.enc.Utf8)
                    )} ),`;
                  } else {
                    selectedRule += ` ${result.value} AND ${JSON.parse(
                      CryptoJS.AES.decrypt(
                        localStorage.getItem("globalFilter"),
                        process.env.REACT_APP_PASS
                      ).toString(CryptoJS.enc.Utf8)
                    )} ),`;
                  }
                  selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                  if (
                    ruleLeveltoggle.length > 0 &&
                    key !== resultData.length - 1 &&
                    ruleLeveltoggle[index] !== undefined &&
                    ruleLeveltoggle[index][key] !== undefined
                  ) {
                    sqlAndOrOperator = ruleLeveltoggle[index][key];
                    selectedRule += ` ${sqlAndOrOperator} `;
                  }
                }
              });
            }
          });
          selectedRule += `)`;
          var position = selectedRule.indexOf(")(") + 1;
          while (position > 0) {
            if (position > 0) {
              selectedRule = [
                selectedRule.slice(0, position),
                " AND ",
                selectedRule.slice(position),
              ].join("");
            }
            position = selectedRule.indexOf(")(") + 1;
          }
          sqlAndOrOperator = "";
          if (
            groupLeveltoggle.length > 0 &&
            tillSqlSelectionArr.length - 1 != index &&
            groupLeveltoggle[0] != undefined &&
            groupLeveltoggle[0][index] != undefined
          ) {
            sqlAndOrOperator = groupLeveltoggle[0][index];
            selectedRule += ` ${sqlAndOrOperator} `;
          }
          selectedRule = selectedRule.replace(/,(\s+)?$/, "");
          this.setState({ query: selectedRule });
        });
      });
      /*let myInitCount = {
        headers: {},
        body: {
          sendgrid: "sendgrid",
          query: this.state.query,
          clientId: JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('clientId'),'secretpass').toString(CryptoJS.enc.Utf8)),
          emailId: "djoshi@cogensia.com",
          givenName: JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('given_name'),'secretpass').toString(CryptoJS.enc.Utf8)),
          lastName: JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('family_name'),'secretpass').toString(CryptoJS.enc.Utf8)),
          title: this.state.title,
          custDb: JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8))
        }
      };
      API.post(apiName, "/counts", myInitCount)
        .then(response => {
          if (response.success !== undefined && response.status !== undefined) {
          } else if (response.status === undefined) {
          }
        })
        .catch(error => {}); */
    }
  }

  handleValidation() {
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    //Name
    if (!fields["listTitle"] && this.state.listTitle == "") {
      formIsValid = false;
      errors["listTitle"] = "Please enter Title";
      this.setState({
        message: "please enter title",
        td: true,
      });
    }

    /*if (!fields["listDesc"] && this.state.listDesc == "") {
      formIsValid = false;
      errors["listDesc"] = "Please enter Description";
      this.setState({
        message: "please enter description",
        td: true
      });
    }*/

    this.setState({ errors: errors });
    setTimeout(
      function() {
        this.setState({
          td: false,
          // message: ""
        });
        // this.props.history.push("/audiences/viewAudiences");
      }.bind(this),
      3000
    );
    return formIsValid;
  }
  SwitchStatus(e) {
    this.setState({ automationSwitchStatus: e });
  }

  switchClientSeedListStatus = (e) => {
    this.setState({ clientSeedListSwitchStatus: e });
  };
  handleModalInput = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
    let fields = this.state.fields;
    fields[event.target.id] = event.target.value;
    this.setState({ fields });
  };

  async getSelection(id) {
    let spinnerItemData = this.state.itemData;
    let spinnerObjIndex = spinnerItemData.findIndex((obj) => obj.id === id);
    spinnerItemData[spinnerObjIndex]["dmCount"] = (
      <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
    );
    spinnerItemData[spinnerObjIndex]["emailCount"] = (
      <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
    );
    spinnerItemData[spinnerObjIndex]["totCustomerCount"] = (
      <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
    );
    spinnerItemData[spinnerObjIndex]["finalCount"] = (
      <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
    );
    spinnerItemData[spinnerObjIndex]["fbCount"] = (
      <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
    );
    spinnerItemData[spinnerObjIndex]["preClubEmail"] = (
      <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
    );
    spinnerItemData[spinnerObjIndex]["eclubEmail"] = (
      <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
    );
    spinnerItemData[spinnerObjIndex]["nonmktCustomer"] = (
      <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
    );
    spinnerItemData[spinnerObjIndex]["noneclubEmails"] = (
      <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
    );
    spinnerItemData[spinnerObjIndex]["nonpreclubEmails"] = (
      <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
    );
    spinnerItemData[spinnerObjIndex]["nonemailCusts"] = (
      <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
    );
    spinnerItemData[spinnerObjIndex]["nonDirectmail"] = (
      <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
    );
    spinnerItemData[spinnerObjIndex]["refreshedAt"] = (
      <i className="fa fa-spinner fa-spin" style={{ fontSize: "18px" }} />
    );
    this.setState({ itemData: spinnerItemData });
    this.hideAlert();
    let path = "/audiences";
    let myInit1 = {
      headers: {
        id: id,
      },
    };
    //Will fetch all the pre selected selections
    await API.get(apiName, path, myInit1).then((response) => {
      this.setState({ selectedRefreshObject: response[0] });
      let ruleLeveltoggle = "";
      let groupLeveltoggle = "";
      let tillSqlSelectionArr = "";
      let afterSqlSelectionArr = "";
      if ("groupLeveltoggle" in response[0]) {
        groupLeveltoggle = response[0]["groupLeveltoggle"];
      }
      if ("ruleLeveltoggle" in response[0]) {
        ruleLeveltoggle = response[0]["ruleLeveltoggle"];
      }
      if ("bSqlSelectionArr" in response[0]) {
        tillSqlSelectionArr = response[0]["bSqlSelectionArr"];
      }
      if ("aSqlSelectionArr" in response[0]) {
        afterSqlSelectionArr = response[0]["aSqlSelectionArr"];
      }
      this.setState({ title: response[0]["title"] });
      let selectedRule = "";
      let selectedOptionValue = "";
      let selectedResult = [];
      let count = 0;
      let sqlAndOrOperator = "";
      tillSqlSelectionArr.map((resultData, index) => {
        selectedRule += `(`;
        resultData.map((options, key) => {
          let length = options.length;
          if (options[length - 2].value.includes("+++")) {
            options[length - 2].value = options[length - 2].value.split(
              "+++"
            )[0];
          }
          if (
            options[length - 1].value === "BETWEEN" ||
            options[length - 1].value === "NOT BETWEEN"
          ) {
            selectedRule += "(";
          }
          if (
            options[length - 1].value === "cardinality(array_intersect(" ||
            options[length - 1].value === "cardinality(array_except("
          ) {
            selectedRule +=
              "(" +
              options[length - 1].value +
              options[length - 2].value +
              ", array";
          } else {
            selectedRule +=
              "(" + options[length - 2].value + " " + options[length - 1].value;
          }
          let data = afterSqlSelectionArr[index][key];
          if (data.length > 0) {
            data.map((result, resultKey) => {
              count = count + 1;
              sqlAndOrOperator = "";
              if (
                options[length - 1].value == "IN" ||
                options[length - 1].value == "NOT IN"
              ) {
                if (resultKey == 0) {
                  selectedRule += `(`;
                }
                if (resultKey == data.length - 1) {
                  let num = result.value;
                  if (typeof num == "string") {
                    selectedRule += ` '${result.value}', `;
                  } else {
                    selectedRule += ` ${result.value}, `;
                  }
                  selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                  selectedRule += `) AND ${JSON.parse(
                    CryptoJS.AES.decrypt(
                      localStorage.getItem("globalFilter"),
                      process.env.REACT_APP_PASS
                    ).toString(CryptoJS.enc.Utf8)
                  )} )`;

                  if (
                    ruleLeveltoggle.length > 0 &&
                    ruleLeveltoggle[index] !== null &&
                    ruleLeveltoggle[index] !== undefined &&
                    ruleLeveltoggle[index][key] !== undefined
                  ) {
                    sqlAndOrOperator = ruleLeveltoggle[index][key];
                    selectedRule += ` ${sqlAndOrOperator} `;
                  }
                } else {
                  let num = result.value;
                  if (typeof num == "string") {
                    selectedRule += ` '${result.value}', `;
                  } else {
                    selectedRule += ` ${result.value}, `;
                  }
                }
              } else if (
                options[length - 1].value == "cardinality(array_intersect("
              ) {
                if (resultKey == 0) {
                  selectedRule += `[`;
                }
                if (resultKey == data.length - 1) {
                  let num = result.value;
                  let aggarray = [];
                  selectedRule += ` '${result.value}', `;
                  selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                  selectedRule += `])) > 0 AND ${JSON.parse(
                    CryptoJS.AES.decrypt(
                      localStorage.getItem("globalFilter"),
                      process.env.REACT_APP_PASS
                    ).toString(CryptoJS.enc.Utf8)
                  )})`;

                  if (
                    ruleLeveltoggle.length > 0 &&
                    ruleLeveltoggle[index] !== undefined &&
                    ruleLeveltoggle[index][key] !== undefined
                  ) {
                    sqlAndOrOperator = ruleLeveltoggle[index][key];
                    selectedRule += ` ${sqlAndOrOperator} `;
                  }
                } else {
                  let num = result.value;
                  selectedRule += ` '${result.value}', `;
                }
              } else if (
                options[length - 1].value == "cardinality(array_except("
              ) {
                if (resultKey == 0) {
                  selectedRule += `[`;
                }
                if (resultKey == data.length - 1) {
                  let num = result.value;
                  let aggarray = [];
                  selectedRule += ` '${result.value}', `;
                  selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                  selectedRule += `])) > 0 AND ${JSON.parse(
                    CryptoJS.AES.decrypt(
                      localStorage.getItem("globalFilter"),
                      process.env.REACT_APP_PASS
                    ).toString(CryptoJS.enc.Utf8)
                  )})`;

                  if (
                    ruleLeveltoggle.length > 0 &&
                    ruleLeveltoggle[index] !== undefined &&
                    ruleLeveltoggle[index][key] !== undefined
                  ) {
                    sqlAndOrOperator = ruleLeveltoggle[index][key];
                    selectedRule += ` ${sqlAndOrOperator} `;
                  }
                } else {
                  let num = result.value;
                  selectedRule += ` '${result.value}', `;
                }
              } else if (options[length - 1].value == "= ") {
                selectedRule += ` ${result.value} AND ${JSON.parse(
                  CryptoJS.AES.decrypt(
                    localStorage.getItem("globalFilter"),
                    process.env.REACT_APP_PASS
                  ).toString(CryptoJS.enc.Utf8)
                )})`;
              } else {
                let num = result.value;
                if (
                  options[length - 1].value === "BETWEEN" ||
                  options[length - 1].value === "NOT BETWEEN"
                ) {
                  selectedRule += ` ${result.value}) AND ${JSON.parse(
                    CryptoJS.AES.decrypt(
                      localStorage.getItem("globalFilter"),
                      process.env.REACT_APP_PASS
                    ).toString(CryptoJS.enc.Utf8)
                  )} ),`;
                } else if (typeof num == "string") {
                  selectedRule += ` '${result.value}' AND ${JSON.parse(
                    CryptoJS.AES.decrypt(
                      localStorage.getItem("globalFilter"),
                      process.env.REACT_APP_PASS
                    ).toString(CryptoJS.enc.Utf8)
                  )} ),`;
                } else {
                  selectedRule += ` ${result.value} AND ${JSON.parse(
                    CryptoJS.AES.decrypt(
                      localStorage.getItem("globalFilter"),
                      process.env.REACT_APP_PASS
                    ).toString(CryptoJS.enc.Utf8)
                  )} ),`;
                }
                selectedRule = selectedRule.replace(/,(\s+)?$/, "");
                if (
                  ruleLeveltoggle.length > 0 &&
                  key !== resultData.length - 1 &&
                  ruleLeveltoggle[index] !== undefined &&
                  ruleLeveltoggle[index][key] !== undefined
                ) {
                  sqlAndOrOperator = ruleLeveltoggle[index][key];
                  selectedRule += ` ${sqlAndOrOperator} `;
                }
              }
            });
          }
        });
        selectedRule += `)`;
        var position = selectedRule.indexOf(")(") + 1;
        while (position > 0) {
          if (position > 0) {
            selectedRule = [
              selectedRule.slice(0, position),
              " AND ",
              selectedRule.slice(position),
            ].join("");
          }
          position = selectedRule.indexOf(")(") + 1;
        }
        sqlAndOrOperator = "";
        if (
          groupLeveltoggle.length > 0 &&
          tillSqlSelectionArr.length - 1 != index &&
          groupLeveltoggle[0] != undefined &&
          groupLeveltoggle[0][index] != undefined
        ) {
          sqlAndOrOperator = groupLeveltoggle[0][index];
          selectedRule += ` ${sqlAndOrOperator} `;
        }
        selectedRule = selectedRule.replace(/,(\s+)?$/, "");
        this.setState({ query: selectedRule });
      });
    });

    let cmpClientIdObject = {
      "8c001fde-3728-48dc-9950-b8480ca9fbee": "33", // Baja Fresh
      "1857ba2f-010f-4f49-bcd1-f9fd09db2799": "22", // Primanti Bro's
      "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f": "13", // Bad Daddy's
      "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534": "30", // Lou Malnatis
      "f0d3b19b-a564-43e9-85dd-bd95f8b13f97": "31", // Data Delivers Cafe / Data Delivers
      "52b86a20-91ae-457b-a6c7-f7708431b645": "1", // HouliHan's
      "19357b26-ddae-4b3a-9e95-b5879f1e9572": "32", // Uncle Julios
      "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9": "9", // SeaFood Grill
      "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406": "1", // HouliHan's NE
      "74d71e90-46e0-45b8-9b6e-a96883e85d54": "4", // Morton's
      "7abec586-17b8-4174-993d-e3d86648ed60": "1", // HouliHan's CEN
      "2b7ed789-e2d0-45c0-a45f-49e27d736a7b": "29", // J.Gilbert's
      "c566b59a-7y94-4ag0-96cf-88av8084d1s3": "31", // Cogensia Cafe
      "687c8c2a-0986-4147-bf38-0d5bac9f7530": "36", // Eegee's
      "b44cc84d-73b5-4457-bb48-68e9626d08e1": "39", // Viva Chicken
      "ca2d8a6b-0eb8-48e2-b81a-41d12c14e04c": "38", // Brusters
      "535a90f3-b463-4d5a-9a83-39c522589a6c": "41", // Mambo
      "ec0df8ce-c87e-4746-a00e-d2c9ee4d7534": "42", //Lous
      "e722fa14-9dbd-11ee-8c90-0242ac120002": "43", // ToC
      "31a73952-d1bf-4647-af62-204b1f56596c": "44", // Pollo Tropical
      "4d288e9e-9254-4513-bb54-072b9f8fc882": "45", // Flag Stop
      "d1522630-2b9d-424e-a399-7ab3f7be274f": "", // Lennys
      "7203dd51-f88b-4a4b-877c-92326d027915": "", // Planet Smoothie
      "83da098f-2fc7-4b98-8455-c08f9aceb4ed": "", // Taco Time
      "cf6144d2-bb68-43b6-9876-dbf620b57c21": "", // Sweet Frog
      "37f97bea-f005-4be1-8e41-286ad79a7f3a": "48", // Bahamabucks
      "ec5a162e-5e87-4819-93bd-70bbf3b5f096": "47", // Brio Bravo
      "24ab940a-50d2-41fd-b3b2-c67ca6cb0304": "", // New Demo Client
      "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac": "49", // Bertucci
      "874b6c6a-83ff-480b-b615-1972538813ba": "50", // Bravo
      "e08840c5-c7d0-48c7-9c24-124b4cd80735": "51", // Ruby Tuesdays
      "b76e7818-deb1-4526-93a7-b398df3ea357": "27", // Goodtimes
      "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e": "52", // Firebirds
      "0bc2a383-9ae0-4e9e-9652-0fb762ba6119": "55", // Wow Car Wash
      "7bf99619-30a3-47a3-b1de-d72b4f7f99a7": "53", // Better Buzz
      "a4dda78e-7678-4aaf-9bef-60a229085fc8": "54", // Smoothie King
      // The client id needs to be added for Mambo in the above line after creating the record in the cmp-clients table
    };

    let custIdToBeSuppressed = "";
    if (
      this.state.localStorageClientId === "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534"
    ) {
      custIdToBeSuppressed = JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("suppressionCustId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      );
    }

    let tempQuery = "";
    if (this.state.selectedTemplate == "Email") {
      tempQuery =
        "SELECT " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("channelsAllObj"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ).filter(
          (obj) =>
            obj.id ===
            JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("activeChannel"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            )
        )[0]["counts"] +
        " FROM " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".cust_analytic ca LEFT JOIN " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept " +
        "WHERE true AND " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("globalFilter"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        (this.state.query !== "" ? " AND " + this.state.query : "");
      if (this.state.query.includes("li.")) {
        tempQuery =
          "SELECT " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("channelsAllObj"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ).filter(
            (obj) =>
              obj.id ===
              JSON.parse(
                CryptoJS.AES.decrypt(
                  localStorage.getItem("activeChannel"),
                  process.env.REACT_APP_PASS
                ).toString(CryptoJS.enc.Utf8)
              )
          )[0]["counts"] +
          " FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".cust_analytic ca LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ).split("_")[0] +
          "_raw.lists_preclub li ON li.cust_id = ca.cust_id " +
          "WHERE true AND " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("globalFilter"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        (this.state.query !== "" ? " AND " + this.state.query : "");
      }
    }
    else if (this.state.selectedTemplate == "PreClub") {
      tempQuery =
        "SELECT " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("channelsAllObj"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ).filter(
          (obj) =>
            obj.id ===
            JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("activeChannel"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            )
        )[0]["counts"] +
        " FROM " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".cust_analytic ca LEFT JOIN " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
        ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
          cmpClientIdObject[
            JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("clientId"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            )
          ]
        }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
          cmpClientIdObject[
            JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("clientId"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            )
          ]
        }'),false ,true) or client_complaints is null))) AND ` +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("globalFilter"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        (this.state.query !== "" ? " AND " + this.state.query : "");
      if (this.state.query.includes("li.")) {
        tempQuery =
          "SELECT " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("channelsAllObj"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ).filter(
            (obj) =>
              obj.id ===
              JSON.parse(
                CryptoJS.AES.decrypt(
                  localStorage.getItem("activeChannel"),
                  process.env.REACT_APP_PASS
                ).toString(CryptoJS.enc.Utf8)
              )
          )[0]["counts"] +
          " FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".cust_analytic ca LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ).split("_")[0] +
          "_raw.lists_preclub li ON li.cust_id = ca.cust_id LEFT JOIN " +
          ` cog_messages_curated.email_master_status ms ON oe.email_address = ms.email_address where (ca.global_control_flag = true or (final_reason['status'] = '1' and ca.global_control_flag = false and (if(contains(client_unsubscribes, '${
            cmpClientIdObject[
              JSON.parse(
                CryptoJS.AES.decrypt(
                  localStorage.getItem("clientId"),
                  process.env.REACT_APP_PASS
                ).toString(CryptoJS.enc.Utf8)
              )
            ]
          }'),False ,True) or client_unsubscribes is null) and (if(contains(client_complaints, '${
            cmpClientIdObject[
              JSON.parse(
                CryptoJS.AES.decrypt(
                  localStorage.getItem("clientId"),
                  process.env.REACT_APP_PASS
                ).toString(CryptoJS.enc.Utf8)
              )
            ]
          }'),false ,true) or client_complaints is null))) AND ` +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("globalFilter"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          (this.state.query !== "" ? " AND " + this.state.query : "");
      }
    } else {
      tempQuery =
        "SELECT " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("channelsAllObj"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ).filter(
          (obj) =>
            obj.id ===
            JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("activeChannel"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            )
        )[0]["counts"] +
        " FROM " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".cust_analytic ca LEFT JOIN " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept WHERE " +
        JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("globalFilter"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ) +
        (this.state.query !== "" ? " AND " + this.state.query : "") +
        (this.state.localStorageClientId ===
        "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534"
          ? `AND ca.cust_id <> '${custIdToBeSuppressed}'`
          : "");
      if (this.state.query.includes("li.")) {
        tempQuery =
          "SELECT " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("channelsAllObj"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ).filter(
            (obj) =>
              obj.id ===
              JSON.parse(
                CryptoJS.AES.decrypt(
                  localStorage.getItem("activeChannel"),
                  process.env.REACT_APP_PASS
                ).toString(CryptoJS.enc.Utf8)
              )
          )[0]["counts"] +
          " FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".cust_analytic ca LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN (SELECT * FROM (SELECT rank() OVER (partition by email_address, geo_concept ORDER BY em_match_level, cust_id) rank, * FROM " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".owned_email ) WHERE rank = 1 ) oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          ".loyalty lo ON lo.cust_id = ca.cust_id AND lo.geo_concept = ca.geo_concept LEFT JOIN " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("custDb"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ).split("_")[0] +
          "_raw.lists_preclub li ON li.cust_id = ca.cust_id WHERE " +
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("globalFilter"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ) +
          (this.state.query !== "" ? " AND " + this.state.query : "")(
            this.state.localStorageClientId ===
            "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534"
              ? `AND ca.cust_id <> '${custIdToBeSuppressed}'`
              : ""
          );
      }
    }
    // if (
    //   this.state.localStorageClientId === "712cc8e9-3a79-4900-b122-ec9812e0f0ca"
    // ) {
    //   tempQuery = tempQuery.replaceAll(
    //     "geo.geo_active",
    //     "cast(geo.geo_active as boolean)"
    //   );
    //   tempQuery = tempQuery.replaceAll(
    //     "if(lo.email_marketable=true,false,true)",
    //     "if(cast(lo.email_marketable as boolean)=true,false,true)"
    //   );
    // }
    let tempStateRefreshObj = this.state.selectedRefreshObject;
    let myInitCount = {
      headers: {},
      body: {
        sql: tempQuery,
        isGeneral: true,
        custDb: JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("custDb"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ),
      },
    };
    API.post(apiName, "/counts", myInitCount)
      .then((response) => {
        if ("final_result" in response) {
          let fRes = JSON.parse(response["final_result"]);
          if (this.state.selectedTemplate == "PreClub" || this.state.selectedTemplate == "Email") {
            this.setState({
              totalexportSelectionCount:
                "Your export file will contain a total of " +
                this.numberWithCommas(fRes["email_addresses"]["total"]) +
                " emails.",
            });
            this.setState({
              exportSelectionCount:
                "There are " +
                this.numberWithCommas(fRes["email_addresses"]["marketable"]) +
                " emails from " +
                this.numberWithCommas(fRes["customers"]["marketable"]) +
                " marketable customers.",
            });
            this.setState({
              nonexportSelectionCount:
                "The other " +
                this.numberWithCommas(fRes["email_addresses"]["control"]) +
                " emails are from " +
                this.numberWithCommas(fRes["customers"]["control"]) +
                " control customers.",
            });
            this.setState({
              noteexportSelectionCount:
                "Control emails will automatically be suppressed upon deployment.",
            });
            this.setState({ loadingInitalSpinner: "false" });
          } else if (this.state.selectedTemplate == "Facebook") {
            this.setState({
              exportSelectionCount:
                "Your export file will contain a total of " +
                this.numberWithCommas(fRes["email_addresses"]["total"]) +
                " emails",
            });
            this.setState({ loadingInitalSpinner: "false" });
          } else if (this.state.selectedTemplate == "Eclub") {
            this.setState({
              totalexportSelectionCount:
                "Your export file will contain a total of " +
                this.numberWithCommas(fRes["email_addresses"]["total"]) +
                " emails.",
            });
            this.setState({
              exportSelectionCount:
                "There are " +
                this.numberWithCommas(fRes["email_addresses"]["marketable"]) +
                " emails from " +
                this.numberWithCommas(fRes["customers"]["marketable"]) +
                " marketable customers.",
            });
            this.setState({
              nonexportSelectionCount:
                "The other " +
                this.numberWithCommas(fRes["email_addresses"]["control"]) +
                " emails are from " +
                this.numberWithCommas(fRes["customers"]["control"]) +
                " control customers.",
            });
            this.setState({
              noteexportSelectionCount:
                "Control emails will automatically be suppressed upon deployment.",
            });
            this.setState({ loadingInitalSpinner: "false" });
          } else if (this.state.selectedTemplate == "Loyalty") {
            this.setState({
              totalexportSelectionCount:
                "Your export file will contain a total of " +
                this.numberWithCommas(fRes["email_addresses"]["total"]) +
                " emails.",
            });
            this.setState({
              exportSelectionCount:
                "There are " +
                this.numberWithCommas(fRes["email_addresses"]["marketable"]) +
                " emails from " +
                this.numberWithCommas(fRes["customers"]["marketable"]) +
                " marketable customers.",
            });
            this.setState({
              nonexportSelectionCount:
                "The other " +
                this.numberWithCommas(fRes["email_addresses"]["control"]) +
                " emails are from " +
                this.numberWithCommas(fRes["customers"]["control"]) +
                " control customers.",
            });
            this.setState({
              noteexportSelectionCount:
                "Control emails will automatically be suppressed upon deployment.",
            });
            this.setState({ loadingInitalSpinner: "false" });
          } else {
            this.setState({
              exportSelectionCount:
                "Your export file will include " +
                this.numberWithCommas(fRes["email_addresses"]["marketable"]) +
                " marketable email addressess \n for " +
                this.numberWithCommas(fRes["customers"]["marketable"]) +
                " marketable customers",
            });
            this.setState({ loadingInitalSpinner: "false" });
          }
        }
      })
      .catch((error) => {});
  }

  handleClose(modal) {
    var x = [];
    x[modal] = false;
    this.setState(x);
    this.setState({ exportSelectionCount: "" });
    this.setState({ nonexportSelectionCount: "" });
    this.setState({ totalexportSelectionCount: "" });
    this.setState({ noteexportSelectionCount: "" });
    this.setState({ selectedTemplate: "" });
    this.setState({ deploymentName: "" });
    this.setState({ selectedChannelType: "" });
    this.setState({ selectedChannel: "" });
    this.setState({ automationTimestamp: 0 });
  }
  // onCheckbox(key) {
  //   let keyposition = checkedArr.indexOf(key);
  //   if (checkedArr.length === 0) {
  //     checkedArr.push(key);
  //   } else {
  //     if (keyposition === -1) {
  //       checkedArr.push(key);
  //       keyposition = checkedArr.indexOf(key);
  //     } else {
  //       keyposition = checkedArr.indexOf(key); // Find the index position of key....
  //       checkedArr.splice(keyposition, 1); //....then remove that one element from that position
  //     }
  //   }
  //   this.setState({ checked: true });
  // }
  routeChange() {
    this.setState({
      createAudience: true,
    });
  }
  deleteAudience(id) {
    // e.preventDefault();
    checkedArr = [];
    let path = "/audiences";
    let myInit1 = {
      headers: {
        id: id,
        clientid: JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("clientId"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ),
      },
    };
    API.del(apiName, path, myInit1)
      .then((response) => {
        this.setState({
          tr: true,
          message: "Audience deleted successfully",
        });
        //window.location.reload();
        this.getItems(
          JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("clientId"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          )
        );
        checkedArr = [];
        $("input:checkbox").prop("checked", false);
      })
      .catch((error) => {});
  }
  handleClick(id) {
    // e.preventDefault();
    this.setState({
      redirect: true,
      id: id,
    });
    //return <Redirect to="/audiences" data={this.state.id} />;
  }
  //Takes the client Id and fetches all the audiences for the specific client
  getItems(cid) {
    let path = "/audiences";
    let myInit1 = {
      headers: {
        clientId: cid,
      },
    };
    API.get(apiName, path, myInit1)
      .then((response) => {
        let copyOfresponse;

        if (
          this.state.localStorageClientId ===
            "3fe7e557-16f5-406c-bbc8-887fdec7ba8b" ||
          this.state.localStorageClientId ===
            "8c001fde-3728-48dc-9950-b8480ca9fbee" ||
          this.state.localStorageClientId ===
            "dc0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
          this.state.localStorageClientId ===
            "ca2d8a6b-0eb8-48e2-b81a-41d12c14e04c" ||
          this.state.localStorageClientId ===
            "30b8b18b-4a66-4f1a-9ee6-a60bb0da062f" ||
          this.state.localStorageClientId ===
            "1857ba2f-010f-4f49-bcd1-f9fd09db2799" ||
          this.state.localStorageClientId ===
            "b44cc84d-73b5-4457-bb48-68e9626d08e1" ||
          this.state.localStorageClientId ===
            "687c8c2a-0986-4147-bf38-0d5bac9f7530" ||
          this.state.localStorageClientId ===
            "2b7ed789-e2d0-45c0-a45f-49e27d736a7b" ||
          this.state.localStorageClientId ===
            "7abec586-17b8-4174-993d-e3d86648ed60" ||
          this.state.localStorageClientId ===
            "5dbdaf6e-01fc-40c3-acd9-3e1b08d8e406" ||
          this.state.localStorageClientId ===
            "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9" ||
          this.state.localStorageClientId ===
            "535a90f3-b463-4d5a-9a83-39c522589a6c" ||
          this.state.localStorageClientId ===
            "9501c9a1-6d0c-4285-a44f-64b1db4b3f91" ||
          this.state.localStorageClientId ===
            "acf275e9-3f68-4250-9f8a-e80672b133f3" ||
          this.state.localStorageClientId ===
            "ec0df8ce-c87e-4746-a00e-d2c9ee4d7534" ||
          this.state.localStorageClientId === 
            "e722fa14-9dbd-11ee-8c90-0242ac120002" ||
          this.state.localStorageClientId ===
            "31a73952-d1bf-4647-af62-204b1f56596c" ||
          this.state.localStorageClientId === 
            "4d288e9e-9254-4513-bb54-072b9f8fc882" ||
          this.state.localStorageClientId ===
            "d1522630-2b9d-424e-a399-7ab3f7be274f" ||
          this.state.localStorageClientId ===
            "7203dd51-f88b-4a4b-877c-92326d027915" ||
          this.state.localStorageClientId ===
            "f1fbce23-e2ef-463c-bc97-6cde3c4cc4ac" ||
          this.state.localStorageClientId ===
            "874b6c6a-83ff-480b-b615-1972538813ba" ||
          this.state.localStorageClientId === 
            "b76e7818-deb1-4526-93a7-b398df3ea357" ||
          this.state.localStorageClientId === 
            "e08840c5-c7d0-48c7-9c24-124b4cd80735" ||
          this.state.localStorageClientId === 
            "68a4d4cc-1e57-4ccf-9dd1-a5ae890d0f2e" ||
          this.state.localStorageClientId === 
            "0bc2a383-9ae0-4e9e-9652-0fb762ba6119" ||
          this.state.localStorageClientId === 
            "7bf99619-30a3-47a3-b1de-d72b4f7f99a7" ||
          this.state.localStorageClientId === 
            "a4dda78e-7678-4aaf-9bef-60a229085fc8" ||
          this.state.localStorageClientId === 
            "cf6144d2-bb68-43b6-9876-dbf620b57c21" ||
          this.state.localStorageClientId === 
            "83da098f-2fc7-4b98-8455-c08f9aceb4ed" ||
          this.state.localStorageClientId ===
            "37f97bea-f005-4be1-8e41-286ad79a7f3a" ||
          this.state.localStorageClientId ===
            "ec5a162e-5e87-4819-93bd-70bbf3b5f096" ||
          this.state.localStorageClientId ===
            "24ab940a-50d2-41fd-b3b2-c67ca6cb0304"
        ) {
          copyOfresponse = response
            .filter(
              (x) =>
                x.clientConcept === "ca.geo_concept = '1'" ||
                x.clientConcept === "ca.geo_concept = '3'" ||
                x.clientConcept === "di.geo_concept = '1'" ||
                x.clientConcept === "di.geo_concept = '3'"
            )
            .sort((a, b) => (a.modifiedAt < b.modifiedAt ? 1 : -1));
        } else {
          copyOfresponse = response
            .filter(
              (x) =>
                x.clientConcept ==
                JSON.parse(
                  CryptoJS.AES.decrypt(
                    localStorage.getItem("globalFilter"),
                    process.env.REACT_APP_PASS
                  ).toString(CryptoJS.enc.Utf8)
                )
            )
            .sort((a, b) => (a.modifiedAt < b.modifiedAt ? 1 : -1));
        }

        //let copyOfresponse response
        //   .filter(
        //     (x) =>
        //       x.clientConcept ==
        //       JSON.parse(
        //         CryptoJS.AES.decrypt(
        //           localStorage.getItem("globalFilter"),
        //           process.env.REACT_APP_PASS
        //         ).toString(CryptoJS.enc.Utf8)
        //       )
        //   )
        //   .sort((a, b) => (a.modifiedAt < b.modifiedAt ? 1 : -1));

        // Code block to replace the text Acquistion with Prospect to display in the table.
        copyOfresponse.forEach(function(item) {
          if (item.customerType === "Acquistion") {
            item.customerType = "Prospect";
          }
        });

        for (let i in copyOfresponse) {
          copyOfresponse[i]["actions"] = (
            <div className="actions-right">
              <Tooltip title="Edit">
                <Button
                  justIcon
                  color="success"
                  onClick={() => {
                    if(copyOfresponse[i].hasOwnProperty('version')) {
                      handleInitalAudienceEdit(copyOfresponse[i])
                    }
                    else {
                      this.handleClick(copyOfresponse[i]["id"])
                    }
                  }}
                >
                  <i
                    style={{ fontSize: "14px" }}
                    className={"fa fa-edit fa-1x"}
                  />
                </Button>
              </Tooltip>

              <Tooltip title="Delete">
                <Button
                  justIcon
                  color="danger"
                  onClick={() =>
                    this.warningWithConfirmMessage(copyOfresponse[i]["id"])
                  }
                >
                  <i
                    style={{ fontSize: "14px" }}
                    className={"fa fa-trash fa-1x"}
                  />
                </Button>
              </Tooltip>
              <br />
              {/* {this.state.localStorageClientId !== */}
              {/*   "2bdbd6af-6cd3-4358-a1a0-437226a20ee9" && */}
              {/*   this.state.localStorageClientId !== */}
              {/*     "712cc8e9-3a79-4900-b122-ec9812e0f0ca" && ( */}
              {/*     <Tooltip title="Make list"> */}
              {/*       <Button */}
              {/*         justIcon */}
              {/*         color="info" */}
              {/*         onClick={() => { */}
              {/*           checkedArr = []; */}
              {/*           subList = []; */}
              {/*           multiSubList = []; */}
              {/*           labelsMap = new Map(); */}
              {/*           this.setState( */}
              {/*             { */}
              {/*               checked: [], */}
              {/*               selectAll: false, */}
              {/*               exportSelectionCount: "", */}
              {/*               nonexportSelectionCount: "", */}
              {/*               noteexportSelectionCount: "", */}
              {/*               totalexportSelectionCount: "", */}
              {/*               selectedAudienceChannelId: */}
              {/*                 copyOfresponse[i]["counts"][0].channelId, */}
              {/*             }, */}
              {/*             () => { */}
              {/*               // Added this in the setState callback so as to get the selected Audience Channel Id value in the method. */}
              {/*               this.exportColumns( */}
              {/*                 copyOfresponse[i]["id"], */}
              {/*                 "classicModal", */}
              {/*                 1 */}
              {/*               ); */}
              {/*             } */}
              {/*           ); */}
              {/*           // this.exportColumns( */}
              {/*           //   copyOfresponse[i]["id"], */}
              {/*           //   "classicModal", */}
              {/*           //   1 */}
              {/*           // ); */}
              {/*         }} */}
              {/*       > */}
              {/*         <i */}
              {/*           style={{ fontSize: "14px", hover: "text" }} */}
              {/*           className={"fa fa-th-list fa-1x"} */}
              {/*         /> */}
              {/*       </Button> */}
              {/*     </Tooltip> */}
              {/*   )} */}

              {/*<Tooltip title="Refresh">
            <Button
                justIcon
                color="default"
                onClick={() => {
                //this.getSelection(list.id);
                this.refreshCountConfirmMessage(copyOfresponse[i]['id']);
                }}
            >
                <Refresh  />
            </Button>
          </Tooltip>*/}
              <Tooltip title="Create Automation">
                <Button
                  justIcon
                  style={{ "background-color": "#69ff45" }}
                  onClick={() => {
                    this.setState({ showOrHideClientSeedListSwitch: "none" });
                    this.setState({ clientSeedListSwitchStatus: false });
                    this.setState({ deploymentModal: true });
                    this.setState({ automationSwitchStatus: true });
                    this.setState({ audienceId: copyOfresponse[i]["id"] });
                    this.setState({
                      audienceTitle: copyOfresponse[i]["title"],
                    });
                    this.getCampaigns();
                    this.fetchAllSendgridTemplates();
                    let myArrayFiltered = [];
                    if(copyOfresponse[i].hasOwnProperty('version')) {
                      // Filter Based on Current Chanels
                      let clientChannelArray = JSON.parse(
                        CryptoJS.AES.decrypt(
                          localStorage.getItem("channels"),
                          process.env.REACT_APP_PASS
                        ).toString(CryptoJS.enc.Utf8))
                        myArrayFiltered = this.state.automationDropSelection.filter((a) => clientChannelArray.includes(a.value))
                        myArrayFiltered = myArrayFiltered.sort((a, b) => a.label.localeCompare(b.label))
                    }
                    // MAINTAIN LEGACY FUNCTIONALITY FOR OLD AUDIENCES
                    else {
                      if (copyOfresponse[i]["customerType"] === "Prospect") {
                        myArrayFiltered = this.state.automationDropSelection.filter(
                          (el) => {
                            return this.state.acquisitionChannelId.some((f) => {
                              return f.id === el.value;
                            });
                          }
                        );
                      } else if (
                        copyOfresponse[i]["customerType"] === "Customer"
                      ) {
                        myArrayFiltered = this.state.automationDropSelection.filter(
                          (el) => {
                            return this.state.customerChannelId.some((f) => {
                              return f.id === el.value;
                            });
                          }
                        );
                      } else {
                        myArrayFiltered = this.state.automationDropSelection.filter(
                          (el) => {
                            return this.state.combinedChannelId.some((f) => {
                              return f.id === el.value;
                            });
                          }
                        );
                      }
                    }
                    this.setState({automationDropSelectionModified: myArrayFiltered});
                  }}
                >
                  <UpdateIcon />
                </Button>
              </Tooltip>
              <Tooltip title="Counts">
                <Button
                  justIcon
                  style={{ "background-color": "#0014ff" }}
                  onClick={() => this.showCounts(copyOfresponse[i]["counts"])}
                >
                  <i
                    style={{ fontSize: "14px" }}
                    className={"fa fa-certificate fa-1x"}
                  />
                </Button>
              </Tooltip>

              <Tooltip title="Copy">
                <Button
                  justIcon
                  style={{ "background-color": "#b808c3" }}
                  onClick={() => this.copyAudience(copyOfresponse[i]["id"])}
                >
                  <i
                    style={{ fontSize: "14px" }}
                    className={"fa fa-copy fa-1x"}
                  />
                </Button>
              </Tooltip>
            </div>
          );
        }
        this.setState({
          itemData: copyOfresponse,

          loading: false,
          // open: false
        });
        setTimeout(
          function() {
            this.setState({ open: false });
          }.bind(this),
          2000
        );
      })
      .catch((error) => {});
  }

  addFilterPlaceholder = () => {
    const filters = document.querySelectorAll("div.rt-th > input");
    for (let filter of filters) {
      filter.placeholder = "Search";
    }
  };

  //function to sort the results
  filterCaseInsensitive = (filter, row) => {
    const id = filter.pivotId || filter.id;
    return row[id] !== undefined
      ? String(row[id].toLowerCase()).includes(filter.value.toLowerCase())
      : true;
  };

  componentDidMount() {
    this.addFilterPlaceholder();
    this.getItems(
      JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      )
    );
    this.setState({
      localStorageClientId: JSON.parse(
        CryptoJS.AES.decrypt(
          localStorage.getItem("clientId"),
          process.env.REACT_APP_PASS
        ).toString(CryptoJS.enc.Utf8)
      ),
    });
    let c_concept = localStorage.getItem("concept");
    let tempchDisObj = JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem("channelsDisObj"),
        process.env.REACT_APP_PASS
      ).toString(CryptoJS.enc.Utf8)
    );
    for (let l in tempchDisObj) {
      if (tempchDisObj[l] == true) {
        localStorage.setItem(
          "activeChannel",
          CryptoJS.AES.encrypt(JSON.stringify(l), process.env.REACT_APP_PASS).toString()
        );
        break;
      }
    }
    localStorage.setItem(
      "counts",
      CryptoJS.AES.encrypt(JSON.stringify([]), process.env.REACT_APP_PASS).toString()
    );
    let exp_temp = [];
    let clientChannelArray = JSON.parse(
      CryptoJS.AES.decrypt(
        localStorage.getItem("channels"),
        process.env.REACT_APP_PASS
      ).toString(CryptoJS.enc.Utf8)
    );
    let channelPath = "/channels";
    API.get(apiName, channelPath)
      .then((response) => {
        for (let eachResp in response) {
          if (clientChannelArray.includes(response[eachResp]["id"])) {
            response[eachResp]["display"] = JSON.parse(
              CryptoJS.AES.decrypt(
                localStorage.getItem("channelsDisObj"),
                process.env.REACT_APP_PASS
              ).toString(CryptoJS.enc.Utf8)
            )[response[eachResp]["id"]];
            exp_temp.push(response[eachResp]);
          }
        }
        localStorage.setItem(
          "channelsAllObj",
          CryptoJS.AES.encrypt(
            JSON.stringify(exp_temp),
            process.env.REACT_APP_PASS
          ).toString()
        );
        let automationArray = [];
        for (let eachExp in exp_temp) {
          if (exp_temp[eachExp]["display"] == true) {
            let automationObj = {};
            automationObj["label"] = exp_temp[eachExp]["program"];
            automationObj["value"] = exp_temp[eachExp]["id"];
            automationArray.push(automationObj);
          }
        }
        // this.setState({ automationDropSelection: automationArray });
        this.setState({ automationDropSelection: automationArray }, () => {
          this.setState({
            automationDropSelectionModified: this.state.automationDropSelection,
          });
        });
      })
      .catch((error) => {
        console.log(error.response);
      });
    fetch(
      "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/list-formats",
      {
        method: "get",
      }
    )
      .then((res) => res.json())
      .then((result) => {
        if ("Items" in result) {
          if (result["Items"].length > 0) {
            this.setState({ exportTemplate: result["Items"] });
            let optionsArray = [];
            for (let eachExp in result["Items"]) {
              let obj = {};
              obj["label"] = result["Items"][eachExp]["name"];
              obj["value"] = result["Items"][eachExp]["name"];
              obj["cid"] = result["Items"][eachExp]["channelId"];
              optionsArray.push(obj);
            }
            this.setState({ dropDownSelection: optionsArray });
          }
        }
      });
    //let g_con = "ca.geo_concept = '" + c_concept + "'"
    //localStorage.setItem("globalFilter", g_con);
  }
  handleCloseSnackbar = () => {
    this.setState({ open: false });
  };
  saveCopyAudience() {
    if (this.state.copyTitle == "") {
      let err = {};
      err["copyTitle"] = "Please enter Title";
      this.setState({ errors: err });
      setTimeout(
        function() {
          this.setState({
            errors: (err["copyTitle"] = ""),
          });
          // this.props.history.push("/audiences/viewAudiences");
        }.bind(this),
        3000
      );
    } else if (this.state.copyDescription == "") {
      let err = {};
      err["copyDescription"] = "Please enter Description";
      this.setState({ errors: err });
      setTimeout(
        function() {
          this.setState({
            errors: (err["copyDescription"] = ""),
          });
          // this.props.history.push("/audiences/viewAudiences");
        }.bind(this),
        3000
      );
    } else {
      const uuidv4 = require("uuid/v4");
      let newUuid = uuidv4();
      let y = this.state.duplicateAudience;
      y["title"] = this.state.copyTitle;
      y["description"] = this.state.copyDescription;
      y["id"] = newUuid;
      (y["modifiedAt"] = new Date()
        .toJSON()
        .slice(0, 10)
        .replace(/-/g, "/")),
        (y["createdAt"] = new Date()
          .toJSON()
          .slice(0, 10)
          .replace(/-/g, "/")),
        (y["userId"] = JSON.parse(
          CryptoJS.AES.decrypt(
            localStorage.getItem("userId"),
            process.env.REACT_APP_PASS
          ).toString(CryptoJS.enc.Utf8)
        ));
      let path = "/audiences";
      let audienceParam = {
        headers: {},
        body: y,
      };
      API.post(apiName, path, audienceParam)
        .then((response) => {
          this.setState({ copyAudienceModal: false });
          window.location.reload(true);
        })
        .catch((error) => {
          console.log(error.response);
        });
    }
  }
  copyAudience(id) {
    let path = "/audiences";
    let audienceParam = {
      headers: {
        id: id,
      },
    };
    //Will fetch all the pre selected selections
    API.get(apiName, path, audienceParam)
      .then((response) => {
        this.setState({ duplicateAudience: response[0] });
        this.setState({ copyDescription: response[0]["description"] });
        this.setState({ copyTitle: response[0]["title"] + " - copy" });
        this.setState({ copyAudienceModal: true });
      })
      .catch((error) => {
        console.log(error);
      });
  }
  warningWithConfirmMessage(id) {
    this.setState({
      alert: (
        <SweetAlert
          style={{
            display: "block",
            marginTop: "-100px",
            textTransform: "none",
          }}
          title="Are you sure you want to delete?"
          onConfirm={() => this.successDelete(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
          cancelBtnCssClass={
            this.props.classes.button + " " + this.props.classes.danger
          }
          confirmBtnText="Yes"
          cancelBtnText="No"
          showCancel
        />
      ),
    });
  }

  showCounts(id) {
    if (id !== undefined) {
      this.setState({
        showCountsAlert: (
          <SweetAlert
            style={{
              display: "block",
              marginTop: "-100px",
              textTransform: "none",
            }}
            title={"Counts"}
            onConfirm={() => this.setState({ showCountsAlert: null })}
            //onCancel={() => this.setState({showCountsAlert: null})}
            confirmBtnCssClass={
              this.props.classes.button + " " + this.props.classes.success
            }
            //cancelBtnCssClass={
            //  this.props.classes.button + " " + this.props.classes.danger
            //}
            confirmBtnText="Close"
            //cancelBtnText="close"
            //showCancel
          >
            {id.map((link) => (
              <h2
                style={{
                  paddingLeft: "22px",
                  textAlign: "left",
                  float: "center",
                  color: "#417a94",
                  paddingBottom: "20px",
                }}
              >
                {
                  this.state.automationDropSelection.filter((obj) => {
                    return obj.value === link.channelId;
                  })[0]["label"]
                }{" "}
                <br style={{ paddingRight: "20px" }} /> Customer:{" "}
                {this.numberWithCommas(link.counts[0].customers.total)}{" "}
                <br style={{ paddingRight: "20px" }} /> Email Address:{" "}
                {link.counts[0].email_addresses !== undefined
                  ? this.numberWithCommas(link.counts[0].email_addresses.total)
                  : this.numberWithCommas(link.counts[0].emails.total)}
              </h2>
            ))}
          </SweetAlert>
        ),
      });
    }
  }

  refreshCountConfirmMessage(id) {
    this.setState({
      alert: (
        <SweetAlert
          style={{
            display: "block",
            marginTop: "-100px",
            textTransform: "none",
          }}
          title="Are you sure you want to refresh counts?"
          onConfirm={() => this.getSelection(id)}
          onCancel={() => this.hideAlert()}
          confirmBtnCssClass={
            this.props.classes.button + " " + this.props.classes.success
          }
          cancelBtnCssClass={
            this.props.classes.button + " " + this.props.classes.danger
          }
          confirmBtnText="Yes"
          cancelBtnText="No"
          showCancel
        />
      ),
    });
  }

  hideAlert() {
    this.setState({
      alert: null,
    });
  }
  successDelete(id) {
    // this.setState({
    //   alert: (
    //     <SweetAlert
    //       success
    //       style={{ display: "block", marginTop: "-100px" }}
    //       title="Deleted!"
    //       onConfirm={() => this.hideAlert()}
    //       showConfirm={false}
    //       confirmBtnCssClass={
    //         this.props.classes.button + " " + this.props.classes.success
    //       }
    //     >
    //       Record has been deleted.
    //     </SweetAlert>
    //   )
    // });
    this.deleteAudience(id);
    this.hideAlert();
  }
  checkSelectAll() {}
  handleToggle(value, label) {
    const { checked } = this.state;
    const { checkedValues } = this.state;
    // const checked = this.state.checked;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
      checkedValues.push(value);
      labelsMap.set(value, label);
    } else {
      labelsMap.delete(value);
      newChecked.splice(currentIndex, 1);
      checkedValues.splice(currentIndex, 1);
    }
    this.setState({
      checked: newChecked,
    });
  }
  handleTags(regularTags) {
    this.setState({ checked: regularTags });
  }
  handleDelete = (label) => () => {
    this.handleToggle(label, labelsMap.get(label));
    // this.setState(state => {
    //   const chipData = [...state.chipData];
    //   const chipToDelete = chipData.indexOf(data);
    //   chipData.splice(chipToDelete, 1);
    //   return { chipData };
    // });
  };
  verifyEmail(value) {
    var emailRex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (emailRex.test(value)) {
      return true;
    }
    return false;
  }

  handleselectedTypeInputfields(e, stif) {
    let cpIF = this.state.selectedTypeInputfields;
    for (let eachIf in cpIF) {
      if (cpIF[eachIf]["fieldName"] == stif) {
        cpIF[eachIf]["fieldValue"] = e.target.value;
      }
    }
    this.setState({ selectedTypeInputfields: cpIF });
  }
  RecurringToggleChange(rte) {
    this.setState({ recurring: rte });
    this.setState({ recurringValue: "" });
  }
  handleTemplateChanges(e, stif) {
    let cpIF = this.state.selectedTypeInputfields;
    for (let eachIf in cpIF) {
      if (cpIF[eachIf]["fieldName"] == stif) {
        cpIF[eachIf]["fieldValue"] = e.value;
      }
    }
    this.setState({ selectedTypeInputfields: cpIF });
  }
  fetchAllSendgridTemplates() {
    fetch(
      "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/sendgrid-templates",
      {
        method: "get",
        headers: {
          clientId: JSON.parse(
            CryptoJS.AES.decrypt(
              localStorage.getItem("clientId"),
              process.env.REACT_APP_PASS
            ).toString(CryptoJS.enc.Utf8)
          ),
        },
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({ allTemplates: result });
        },
        (error) => {}
      );
  }
  handleChannelTypeChange = (event) => {
    this.setState({ selectedChannelType: event.value });
    fetch(
      "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/channel-action",
      {
        method: "get",
        headers: { channelId: this.state.selectedChannel },
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          if ("Items" in result) {
            if (result["Items"].length > 0) {
              let channelActions = result["Items"];
              for (let eachCA in channelActions) {
                if (channelActions[eachCA]["id"] == event.value) {
                  if ("inputFieldsRequired" in channelActions[eachCA]) {
                    this.setState({
                      selectedTypeInputfields:
                        channelActions[eachCA]["inputFieldsRequired"],
                    });
                  }
                }
              }
            }
          }
        },
        (error) => {}
      );
  };
  handleChannelChange = (event) => {
    this.setState({ selectedTypeInputfields: [] });
    this.setState({ selectedChannel: event.value }, () => {
      // Added functionality to enable the Client Seed List toggle only if the selected channel is preclub.
      if (
        this.state.selectedChannel === "0905c46e-6f48-4ed8-b2a9-35dbbf3bae91" ||
        this.state.selectedChannel === "2cc3399e-3b2e-49e3-a48c-71367af222f8"
      ) {
        this.setState({
          showOrHideClientSeedListSwitch: "",
        });
      } else {
        this.setState({
          showOrHideClientSeedListSwitch: "none",
        });
      }
    });
    fetch(
      "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/channel-action",
      {
        method: "get",
        headers: { channelId: event.value },
      }
    )
      .then((res) => res.json())
      .then(
        (result) => {
          if ("Items" in result) {
            if (result["Items"].length > 0) {
              let channelActions = result["Items"];
              let channelOptArray = [];
              for (let eachCA in channelActions) {
                let channelOpt = {};
                channelOpt["label"] = channelActions[eachCA]["name"];
                channelOpt["value"] = channelActions[eachCA]["id"];
                channelOptArray.push(channelOpt);
              }
              this.setState({ channelTypesDropSelection: channelOptArray });
            }
          }
        },
        (error) => {}
      );
  };
  handleFriendlyFromSelectionChange = (event) => {
    this.setState({ selectedFriendlyFromOption: event.value }, () => {
      console.log(
        "The Selected Friendly From option is : " +
          this.state.selectedFriendlyFromOption
      );
    });
  };
  exportAutomation() {
    let exCpif = this.state.selectedTypeInputfields;
    let exCpifFlag = true;
    let exInputFieldObj = {};
    for (let eachexCpIf in exCpif) {
      if ("fieldValue" in exCpif[eachexCpIf]) {
        if (exCpif[eachexCpIf]["fieldValue"] == "") {
          exCpifFlag = false;
        } else {
          exInputFieldObj[exCpif[eachexCpIf]["fieldName"]] =
            exCpif[eachexCpIf]["fieldValue"];
        }
      } else {
        exCpifFlag = false;
      }
    }

    // Check Offer Value 
    if(spendgoOffercode(this.state.localStorageClientId, this.state.selectedChannel) && !this.state.offerCodeValue) {
      let err = {};
      err["offerCodeValue"] = "Please Enter a SpendGo Campaign ID";
      this.setState({ errors: err });
      setTimeout(
        function() {
          this.setState({
            errors: (err["offerCodeValue"] = ""),
          });
          // this.props.history.push("/audiences/viewAudiences");
        }.bind(this),
        3000
      );
      this.setState({ exportDisable: false });
    }
    else if (this.state.selectedChannel == "") {
      this.setState({ error: true });
      setTimeout(
        function() {
          this.setState({
            error: false,
          });
        }.bind(this),
        3000
      );
      this.setState({ exportDisable: false });
    } else if (this.state.selectedChannelType == "") {
      this.setState({ channeltypeerror: true });
      setTimeout(
        function() {
          this.setState({
            channeltypeerror: false,
          });
        }.bind(this),
        3000
      );
      this.setState({ exportDisable: false });
    } else if (exCpifFlag == false) {
      this.setState({ exInputFieldserror: true });
      setTimeout(
        function() {
          this.setState({
            exInputFieldserror: false,
          });
        }.bind(this),
        3000
      );
      this.setState({ exportDisable: false });
    } else if (this.state.deploymentName == "") {
      let err = {};
      err["deploymentName"] = "Please enter Name";
      this.setState({ errors: err });
      setTimeout(
        function() {
          this.setState({
            errors: (err["deploymentName"] = ""),
          });
          // this.props.history.push("/audiences/viewAudiences");
        }.bind(this),
        3000
      );
      this.setState({ exportDisable: false });
    } else if (
      this.state.localStorageClientId ===
        "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9" &&
      this.state.selectedFriendlyFromOption === ""
    ) {
      this.setState({ friendlyFromOptionError: true });
      setTimeout(
        function() {
          this.setState({
            friendlyFromOptionError: false,
          });
        }.bind(this),
        3000
      );
      this.setState({ exportDisable: false });
    } else if (this.state.selectedCampaign == "") {
      this.setState({ campaignerror: true });
      setTimeout(
        function() {
          this.setState({
            campaignerror: false,
          });
        }.bind(this),
        3000
      );
      this.setState({ exportDisable: false });
    } else if (this.state.recurring == false) {
      if (this.state.automationTimestamp == 0) {
        let err = {};
        err["automationtimestamp"] = "Please select a valid time";
        this.setState({ errors: err });
        setTimeout(
          function() {
            this.setState({
              errors: (err["automationtimestamp"] = ""),
            });
            // this.props.history.push("/audiences/viewAudiences");
          }.bind(this),
          3000
        );
        this.setState({ exportDisable: false });
      } else {
        let minimumTimeStamp = Math.round(new Date().getTime() / 1000) + 300;
        if (this.state.automationTimestamp <= minimumTimeStamp) {
          let err = {};
          err["automationtimestamp"] = "Please select a valid time";
          this.setState({ errors: err });
          setTimeout(
            function() {
              this.setState({
                errors: (err["automationtimestamp"] = ""),
              });
              // this.props.history.push("/audiences/viewAudiences");
            }.bind(this),
            3000
          );
          this.setState({ exportDisable: false });
        } else {
          const uuidv4 = require("uuid/v4");
          let automationuuid = uuidv4();
          let autopath = "/audiences";
          let autoparam = {
            headers: {
              id: this.state.audienceId,
            },
          };
          API.get(apiName, autopath, autoparam)
            .then((response) => {
              let automationPostObj = {
                id: automationuuid,
                name: this.state.deploymentName,
                clientId: response[0]["clientId"],
                userId: JSON.parse(
                  CryptoJS.AES.decrypt(
                    localStorage.getItem("userId"),
                    process.env.REACT_APP_PASS
                  ).toString(CryptoJS.enc.Utf8)
                ),
                channelId: this.state.selectedChannel,
                active: this.state.automationSwitchStatus,
                channelParameters: exInputFieldObj,
                campaignId: this.state.selectedCampaign,
                channelActionId: this.state.selectedChannelType,
                audienceId: this.state.audienceId,
                createdAt: Math.round(new Date().getTime() / 1000),
                lastModified: Math.round(new Date().getTime() / 1000),
                //lastTriggered: 0,
                reoccurring: this.state.recurring,
                scheduledStart: this.state.automationTimestamp,
                offerCode: this.state.offerCodeValue,
                offerDuration: this.state.offerCodeDurationValue,
                includeClientSeedList: this.state.clientSeedListSwitchStatus,
                friendlyFrom: this.state.selectedFriendlyFromOption,
              };
              fetch(
                "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/automations",
                {
                  method: "post",
                  body: JSON.stringify(automationPostObj),
                }
              )
                .then((res) => res.json())
                .then((result) => {
                  this.setState({ deploymentName: "" });
                  this.setState({ selectedChannel: "" });
                  this.setState({ selectedChannelType: "" });
                  this.setState({ automationTimestamp: 0 });
                  this.setState({ automationSwitchStatus: true });
                  this.setState({ selectedCampaign: "" });
                  this.setState({ selectedTypeInputfields: [] });
                  this.setState({ deploymentModal: false });
                  this.setState({ exportDisable: false });
                  this.setState({ automationSnack: true });
                  this.setState({ offerCodeValue: "" });
                  this.setState({ offerCodeDurationValue: "" });
                  this.setState({ selectedFriendlyFromOption: "" });
                  setTimeout(
                    function() {
                      this.setState({
                        automationSnack: false,
                      });
                    }.bind(this),
                    6000
                  );
                });
            })
            .catch((error) => {});
        }
      }
    } else {
      if (this.state.recurringValue == "") {
        let err = {};
        err["automationtimestamp"] = "Please select a valid recurring time";
        this.setState({ errors: err });
        setTimeout(
          function() {
            this.setState({
              errors: (err["automationtimestamp"] = ""),
            });
            // this.props.history.push("/audiences/viewAudiences");
          }.bind(this),
          3000
        );
        this.setState({ exportDisable: false });
      } else {
        const uuidv4 = require("uuid/v4");
        let automationuuid = uuidv4();
        let autopath = "/audiences";
        let autoparam = {
          headers: {
            id: this.state.audienceId,
          },
        };
        API.get(apiName, autopath, autoparam)
          .then((response) => {
            let automationPostObj = {
              id: automationuuid,
              name: this.state.deploymentName,
              clientId: response[0]["clientId"],
              userId: JSON.parse(
                CryptoJS.AES.decrypt(
                  localStorage.getItem("userId"),
                  process.env.REACT_APP_PASS
                ).toString(CryptoJS.enc.Utf8)
              ),
              channelId: this.state.selectedChannel,
              active: this.state.automationSwitchStatus,
              channelParameters: exInputFieldObj,
              campaignId: this.state.selectedCampaign,
              channelActionId: this.state.selectedChannelType,
              audienceId: this.state.audienceId,
              createdAt: Math.round(new Date().getTime() / 1000),
              lastModified: Math.round(new Date().getTime() / 1000),
              //lastTriggered: 0,
              reoccurring: this.state.recurring,
              recurringCron: this.state.recurringValue,
              offerCode: this.state.offerCodeValue,
              offerDuration: this.state.offerCodeDurationValue,
              includeClientSeedList: this.state.clientSeedListSwitchStatus,
              friendlyFrom: this.state.selectedFriendlyFromOption,
            };
            fetch(
              "https://73b404h189.execute-api.us-west-2.amazonaws.com/prod/automations",
              {
                method: "post",
                body: JSON.stringify(automationPostObj),
              }
            )
              .then((res) => res.json())
              .then((result) => {
                this.setState({ deploymentName: "" });
                this.setState({ selectedChannel: "" });
                this.setState({ selectedChannelType: "" });
                this.setState({ automationTimestamp: 0 });
                this.setState({ automationSwitchStatus: true });
                this.setState({ selectedCampaign: "" });
                this.setState({ selectedTypeInputfields: [] });
                this.setState({ deploymentModal: false });
                this.setState({ exportDisable: false });
                this.setState({ automationSnack: true });
                this.setState({ offerCodeValue: "" });
                this.setState({ offerCodeDurationValue: "" });
                this.setState({ selectedFriendlyFromOption: "" });
                setTimeout(
                  function() {
                    this.setState({
                      automationSnack: false,
                    });
                  }.bind(this),
                  6000
                );
              });
          })
          .catch((error) => {});
      }
    }
  }

  handleChange = (event) => {
    localStorage.setItem(
      "activeChannel",
      CryptoJS.AES.encrypt(JSON.stringify(event.cid), process.env.REACT_APP_PASS).toString()
    );
    // if (event.value === "Guest Connect") {
    //   this.setState({ selectedTemplate: "PreClub" });
    // } else {
    //   this.setState({ selectedTemplate: event.value });
    // }
    this.setState({ selectedTemplate: event.value });
    this.setState({ loadingInitalSpinner: "true" });
    this.getSelection(this.state.audienceId);
    /*
    let filterExportTemplate = exportTemplate.filter(obj => {return obj.name === event.value})
    let selectionFields = ''
    let fte = filterExportTemplate[0]['fields']
    for (let eachField in fte){
      selectionFields = selectionFields + fte[eachField]['input'] + ' as ' + fte[eachField]['output'] + ','
     }

    let expQuery_1 = '';
    if(event.value == 'PreClub'){
      expQuery_1 = " FROM " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8)) +".cust_analytic ca LEFT JOIN " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8)) +".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8)) + ".owned_email oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8)) + ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8)) + ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept WHERE " + this.state.query + " AND date_diff('month',ca.trans_dt_last,date(array_join(slice(transform(filter(split(ca.\"$path\",'/'),x -> x like '%=%'), x -> split_part(x,'=',2)),1,3),'-'))) <= 48 AND geo.geo_active = true AND oe.clean = true";
    }
   else if(event.value == 'Eclub'){
      expQuery_1 = " FROM " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8)) + ".cust_analytic ca LEFT JOIN " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8)) + ".client_intellibase ci ON ci.cust_id = ca.cust_id LEFT JOIN " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8)) + ".owned_email oe ON oe.cust_id = ca.cust_id AND oe.geo_concept = ca.geo_concept LEFT JOIN " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8)) + ".eclub ec ON ec.cust_id = ca.cust_id AND ec.eclub_geo_concept = ca.geo_concept LEFT JOIN " + JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8)) + ".geo geo ON geo.geo_id = ca.geo_id_fav AND geo.geo_concept = ca.geo_concept WHERE " + this.state.query + " AND geo.geo_active = true AND ec.email_marketable = true";
    }
     
    let finalexpQuery = "select count(*) from (select " + selectionFields.slice(0, -1) + expQuery_1 + ")";
    let myInitCount = {
      headers: {},
      body: {
        sql: finalexpQuery,
        isCustSegment: true,
        custDb: JSON.parse(CryptoJS.AES.decrypt(localStorage.getItem('custDb'),'secretpass').toString(CryptoJS.enc.Utf8))
      }
    };
    API.post(apiName, "/counts", myInitCount)
      .then(response => {
        this.setState({exportSelectionCount: response["final_result"]["Items"][0]['_col0']});
        this.setState({loadingInitalSpinner: 'false'});
      })
      .catch(error => {});
      */
  };

  numberWithCommas(x) {
    return x != undefined
      ? x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      : "";
  }
  handleChangeInput = (event) => {
    this.setState({
      [event.target.id]: event.target.value,
    });
    switch (event.target.id) {
      case "email":
        if (this.verifyEmail(event.target.value)) {
          this.setState({ registerEmailState: "success" });
        } else {
          this.setState({ registerEmailState: "error" });
        }
        break;
      default:
    }
  };
  render() {
    const { classes } = this.props;
    let chipsData = this.state.checked;
    // let chips = chipsData.map((data, idx) => {
    //   return (
    //     <React.Fragment key={idx}>
    //       <span style={{ paddingTop: "10px", border: "1px red" }} />
    //       <Chip
    //         // icon={icon}
    //         label={data}
    //         onDelete={this.handleDelete(data)}
    //         className={classes.chip}
    //       />
    //       <br />
    //     </React.Fragment>
    //   );
    // });
    let chips = [...labelsMap].map((entry) => {
      let key = entry[0];
      let value = entry[1];
      return (
        <GridItem xs={12} key={key}>
          <div style={{ marginBottom: "10px" }}>
            <Chip
              // icon={icon}
              label={value}
              onDelete={this.handleDelete(key)}
              className={classes.chip}
            />
          </div>
        </GridItem>
      );
    });
    let showSpinner =
      this.state.loading === true ? (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <div
              style={{ textAlign: "center", marginTop: "20px", width: "100%" }}
            >
              <i
                className="fa fa-spinner fa-spin"
                style={{ fontSize: "50px" }}
              />
            </div>
          </GridItem>
        </GridContainer>
      ) : (
        "No records found"
      );
    let partial = demoDuplicate.map((list, idx) => {
      subList = list.data;

      const filteredArray = subList.filter((str, i) => {
        if (this.state.search != "") {
          if (
            str.label.toUpperCase().search(this.state.search.toUpperCase()) !=
            -1
          ) {
            return true;
          } else {
            return false;
          }
        } else {
          return str.label.toUpperCase();
        }
      });

      return (
        <React.Fragment key={idx}>
          {/*<h4>{list.label}</h4>*/}

          <GridContainer>
            {filteredArray.map((listData, idx) => {
              if (listData.end == "true") {
                return (
                  // <React.Fragment key={idx}>
                  <GridItem xs={4} key={idx}>
                    <div className={classes.checkboxAndRadio}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            tabIndex={-1}
                            onChange={() =>
                              this.handleToggle(listData.value, listData.label)
                            }
                            color="primary"
                            checked={this.state.checked.includes(
                              listData.value
                            )}
                            classes={{
                              root: classes.root,
                              checked: classes.checked,
                            }}
                          />
                        }
                        classes={{
                          label: classes.label,
                        }}
                        label={listData.label}
                      />
                    </div>
                  </GridItem>
                  // </React.Fragment>
                );
              } else {
                multiSubList = listData.data;
                if (multiSubList != undefined) {
                  return (
                    <React.Fragment>
                      {/* <h4 style={{marginLeft:"15px"}}>{listData.label}</h4> */}
                      {multiSubList.map((multiListData, idx) => {
                        if (
                          multiListData.end == "true" &&
                          idx == 0 &&
                          multiListData.value.indexOf("+++") != -1
                        ) {
                          var res = multiListData.value.split("+++");
                          return (
                            // <React.Fragment key={idx}>
                            <GridItem xs={12} key={idx}>
                              <div className={classes.checkboxAndRadio}>
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      tabIndex={-1}
                                      onChange={() =>
                                        this.handleToggle(
                                          res[0],
                                          listData.label
                                        )
                                      }
                                      color="primary"
                                      checked={this.state.checked.includes(
                                        res[0]
                                      )}
                                      classes={{
                                        root: classes.root,
                                        checked: classes.checked,
                                      }}
                                    />
                                  }
                                  classes={{
                                    label: classes.label,
                                  }}
                                  label={listData.label}
                                />
                              </div>
                            </GridItem>
                            // </React.Fragment>
                          );
                        }
                      })}
                    </React.Fragment>
                  );
                }
              }
            })}
          </GridContainer>
        </React.Fragment>
      );
    });
    const itemData = this.state.itemData;

    if (this.state.redirect === true) {
      let path = "/audiences";
      let myInit1 = {
        headers: {
          id: this.state.id,
        },
      };
      API.get(apiName, path, myInit1)
        .then((response) => {})
        .catch((error) => {});
      return <CreateAudiences id={this.state.id} />;
      //return <Redirect push to={"/audiences/editAudiences/" + this.state.id} />;
    }
    if (this.state.createAudience === true) {
      return <CreateAudiences />;
      // <Redirect push to={"/audiences/createAudiences/"} />;
    }
    return (
      <div>
        <StartForm isShown={this.state.showABStartForm} id={require("uuid/v4")()} onChange={(e)=>{this.setState({showABStartForm: e})}}/>
        <div className="audienceinfo audienlist-info">
          <div className="audiencelistinfo">
            <div className="audiencelistwrap">
              {this.state.alert}
              {this.state.showCountsAlert}
              <GridItem xs={12} sm={12} md={3}>
                <Snackbar
                  place="tr"
                  color={this.state.color}
                  // message={"Automation Saved, go to automations to activate"}
                  message={"Automation saved successfully"}
                  open={this.state.automationSnack}
                  closeNotification={() =>
                    this.setState({ automationSnack: false })
                  }
                  close
                />
              </GridItem>
              <div
                className={
                  this.state.localStorageClientId ===
                  "2bdbd6af-6cd3-4358-a1a0-437226a20ee9"
                    ? "audiencelisttoptitlegoodwill"
                    : "audiencelisttoptitle"
                }
              >
                <h2 className="capitalize" />
                {/* <h2>audience list{checkedArr.length}</h2> */}
                <div className="btngroup">
                  <a
                    className="btn btncreate"
                    onClick={() => this.setState({showABStartForm: true})} // Popup form
                  >
                    CREATE AUDIENCE
                  </a>
                </div>
              </div>
              {/* <div className="audiencelisttoptitle">
                <h2 className="capitalize" /> */}
              {/* <h2>audience list{checkedArr.length}</h2> */}
              {/* <div className="btngroup">
                  <a
                    className="btn btncreate"
                    onClick={() => this.routeChange()}
                  >
                    CREATE AUDIENCE
                  </a>
                </div>
              </div> */}

              {/* <div
                style={{
                  width: "100%",
                  // marginTop: theme.spacing.unit * 3,
                  overflowX: "auto"
                }}
              > */}
              <GridContainer>
                <GridItem xs={12}>
                  <Card>
                    <CardHeader color="warning" icon>
                      <CardIcon color="warning">
                        <Assignment />
                      </CardIcon>
                      <h4 style={{ color: "#0c3c54" }}>Audiences</h4>
                    </CardHeader>
                    <CardBody>
                      <Snackbar
                        message={this.state.message}
                        closeNotification={() => this.setState({ tr: false })}
                        color="success"
                        place="tr"
                        open={this.state.tr}
                        close
                      />
                      <ReactTable
                        data={this.state.itemData}
                        filterable
                        defaultFilterMethod={(filter, row) =>
                          this.filterCaseInsensitive(filter, row)
                        }
                        columns={[
                          {
                            Header: "Title",
                            accessor: "title",
                          },
                          {
                            Header: "Description",
                            accessor: "description",
                          },
                          {
                            Header: "Customer Type	",
                            accessor: "customerType",
                          },
                          {
                            Header: "Creation Date",
                            accessor: "createdAt",
                          },
                          {
                            Header: "Last Modified",
                            accessor: "modifiedAt",
                          },
                          /*{
                              Header: "Counts",
                              accessor: "showCounts"
                            },
                            {
                            /*{
                              Header: "Last Refreshed",
                              accessor: "refreshedAt"
                            },*/
                          {
                            Header: "Last Modified By",
                            accessor: "userName",
                          },
                          /*{
                              Header: "PreClub Control",
                              accessor: "nonpreclubEmails"
                            },
                            {
                              Header: "PreClub Marketable",
                              accessor: "preClubEmail"
                            },
                            {
                              Header: "Total Emails",
                              accessor: "totCustomerCount"
                            },*/
                          {
                            Header: "Actions",
                            accessor: "actions",
                            sortable: false,
                            filterable: false,
                          },
                        ]}
                        defaultPageSize={10}
                        //showPaginationTop
                        showPaginationBottom={true}
                        noDataText={showSpinner}
                        className="-striped -highlight"
                      />
                    </CardBody>
                  </Card>
                </GridItem>
              </GridContainer>
              {/* </div> */}
              <center>
                {/* <div className="sweet-loading">
                  <ClipLoader
                    className={override}
                    sizeUnit={"px"}
                    size={30}
                    color={"#123abc"}
                    loading={this.state.loading}
                  />
                </div> */}
                <Dialog
                  classes={{
                    root: classes.center + " " + classes.modalRoot,
                    paper: classes.modal,
                  }}
                  // style={{ width: "800px" }}
                  open={this.state.classicModal}
                  TransitionComponent={Transition}
                  keepMounted
                  disableBackdropClick
                  disableEscapeKeyDown
                  onClose={() => this.handleClose("classicModal")}
                  aria-labelledby="classic-modal-slide-title"
                  aria-describedby="classic-modal-slide-description"
                >
                  <DialogTitle
                    id="classic-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                    style={{
                      backgroundColor: "#92B54B",
                      borderTopLeftRadius: "6px",
                      borderTopRightRadius: "6px",
                      width: "800px",
                    }}
                  >
                    {/* <Button
                      justIcon
                      className={classes.modalCloseButton}
                      key="close"
                      aria-label="Close"
                      color="transparent"
                      onClick={() => this.handleClose("classicModal")}
                    >
                      <Close className={classes.modalClose} />
                    </Button> */}
                    <h4
                      className={classes.modalTitle}
                      style={{ color: "#fff" }}
                    >
                      <b> Export Audience </b>
                    </h4>
                  </DialogTitle>
                  <DialogContent
                    id="classic-modal-slide-description"
                    className={classes.modalBody}
                  >
                    {/* <Select
                        // value={selectedOption}
                        // onChange={this.handleAcquistionChanges}
                        // options={demoDuplicate}
                        style={{ width: "100%" }}
                        isMulti={true}
                      /> */}
                    <div>
                      {/* <FormControlLabel
                        control={
                          <Checkbox
                            onClick={() => this.handleToggle("value")}
                            color="primary"
                            classes={{
                              root: classes.root,
                              checked: classes.checked
                            }}
                          />
                        }
                        label="Select all properties"
                      /> */}
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                          <h4>Select Template</h4>
                          <Select
                            // value="CSV"
                            onChange={this.handleChange}
                            // options={this.state.dropDownSelection}
                            options={this.state.selectChannelOptionsDropdown}
                          />
                        </GridItem>
                      </GridContainer>
                    </div>
                  </DialogContent>
                  <span
                    style={{ color: "red" }}
                    className={this.state.error ? "block" : "hidden"}
                  >
                    Please select a Template
                  </span>
                  <span>
                    {this.state.loadingInitalSpinner == "false" ? (
                      this.state.selectedTemplate == "" ? (
                        <p />
                      ) : (
                        <div>
                          <GridContainer style={{ textAlign: "center" }}>
                            <GridItem
                              style={{ marginLeft: "5em", marginRight: "5em" }}
                              xs={12}
                              sm={12}
                              md={12}
                            >
                              <h4>Save Your List</h4>
                              <div
                                style={{
                                  paddingLeft: "5em",
                                  paddingRight: "5em",
                                }}
                              >
                                <CustomInput
                                  labelText="List Title"
                                  id="listTitle"
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                  inputProps={{
                                    onChange: (event) =>
                                      this.handleModalInput(event, "listTitle"),
                                  }}
                                />
                                <span className="redColor">
                                  {this.state.errors["listTitle"]}
                                </span>
                                <br />
                                <CustomInput
                                  labelText="List Description"
                                  id="listDesc"
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                  inputProps={{
                                    onChange: (event) =>
                                      this.handleModalInput(event, "listDesc"),
                                  }}
                                />
                                <span className="redColor">
                                  {this.state.errors["listDesc"]}
                                </span>
                                {/*this.state.selectedTemplate == 'PreClub' ? (
                                      Object.keys(subFields).map(subs => (
                                      <GridContainer  style={{textAlign:"left", paddingBottom: "5px"}}>
                                        <GridItem xs={3} sm={3} md={3}>
                                            <label>{subs}</label>
                                        </GridItem>
                                        <GridItem xs={9} sm={9} md={9}>
                                          <CreatableSelect
                                            isClearable
                                            onChange={(opt, meta) =>
                                              this.handleChangeCreatable(subs, opt, meta)
                                            }
                                            //onChange={this.handleChangeCreatable}
                                            //onInputChange={this.handleInputChangeCreatable}
                                            options={subFieldOptions}
                                          />
                                        </GridItem>
                                      </GridContainer>
                                      )
                                      )) : ''
                                       
                                      <br/>
                                      <FormControl fullWidth>
                                        <Datetime
                                          inputProps={{ placeholder: "Pick Deployment Date"}}
                                          isValidDate={ dateValid }
                                          dateFormat='MM/DD/YYYY'
                                          onChange = {this.deploymentDate}
                                          timeFormat={true}
                                        />
                                      </FormControl>
                                      */}
                              </div>
                            </GridItem>
                          </GridContainer>
                          <h2
                            style={{
                              paddingLeft: "22px",
                              textAlign: "left",
                              float: "left",
                              color: "#417a94",
                              paddingBottom: "20px",
                            }}
                          >
                            {this.numberWithCommas(
                              this.state.totalexportSelectionCount
                            )}{" "}
                            <br /> <br />{" "}
                            {this.numberWithCommas(
                              this.state.exportSelectionCount
                            )}{" "}
                            <br />{" "}
                            {this.numberWithCommas(
                              this.state.nonexportSelectionCount
                            )}{" "}
                            <br /> <br /> {this.state.noteexportSelectionCount}
                          </h2>
                        </div>
                      )
                    ) : (
                      <i
                        className="fa fa-spinner fa-spin"
                        style={{ fontSize: "18px" }}
                      />
                    )}
                  </span>
                  <DialogActions className={classes.modalFooter}>
                    <Button
                      onClick={() => this.handleClose("classicModal")}
                      className="btn btncreate"
                      color="secondary"
                    >
                      Cancel
                    </Button>
                    <Button
                      className="btn btncreate"
                      color="secondary"
                      onClick={() => {
                        //this.updateDynamoDB(this.state.audienceId);
                        this.exportColumns(this.state.audienceId, "emailModal");
                      }}
                    >
                      Save
                    </Button>
                  </DialogActions>
                </Dialog>
                <Dialog
                  classes={{
                    root: classes.center + " " + classes.modalRoot,
                    paper: classes.modal,
                  }}
                  open={this.state.emailModal}
                  TransitionComponent={Transition}
                  keepMounted
                  onClose={() => this.handleClose("emailModal")}
                  aria-labelledby="classic-modal-slide-title"
                  aria-describedby="classic-modal-slide-description"
                >
                  <DialogTitle
                    id="classic-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                    style={{
                      backgroundColor: "#92B54B",
                      borderTopLeftRadius: "6px",
                      borderTopRightRadius: "6px",
                    }}
                  >
                    {/* <Button
                          justIcon
                          className={classes.modalCloseButton}
                          key="close"
                          aria-label="Close"
                          color="transparent"
                          onClick={() => this.handleClose("emailModal")}
                        >
                          <Close className={classes.modalClose} />
                        </Button> */}
                    <h4
                      className={classes.modalTitle}
                      style={{ color: "#fff" }}
                    >
                      <b> Save List </b>
                    </h4>
                  </DialogTitle>
                  {this.state.showExportContent ? (
                    <React.Fragment>
                      <DialogContent
                        id="classic-modal-slide-description"
                        className={classes.modalBody}
                      >
                        <div>
                          Your list is being created.
                          <br />
                          You can download your list directly from the{" "}
                          <a href="/lists">Lists page</a>.
                        </div>
                      </DialogContent>
                      {/*<DialogContent
                        id="classic-modal-slide-description"
                        className={classes.modalBody}
                      >
                        <div>
                          <CustomInput
                            success={
                              this.state.registerEmailState === "success"
                            }
                            error={this.state.registerEmailState === "error"}
                            labelText="Email"
                            id="email"
                            formControlProps={{
                              fullWidth: true
                            }}
                            inputProps={{
                              onChange: event =>
                                this.handleChangeInput(event, "email"),
                              value: this.state.email,
                              endAdornment: (
                                <InputAdornment position="end">
                                  <Email
                                    className={classes.inputAdornmentIcon}
                                  />
                                </InputAdornment>
                              )
                            }}
                          />
                          <Select
                            // value="CSV"
                            // onChange={this.handleChange}
                            options={options}
                          />
                        </div>
                          </DialogContent>*/}
                      <DialogActions className={classes.modalFooter}>
                        {/*<Button
                          className="btn btncreate"
                          color="secondary"
                          onClick={() => {
                            this.handleClose("emailModal");
                            this.exportColumns(
                              this.state.audienceId,
                              "classicModal"
                            );
                          }}
                        >
                          Back
                        </Button>
                        <Button
                          className="btn btncreate"
                          onClick={() => this.updateDynamoDB(this.state.audienceId)}
                          color="secondary"
                        >
                          Submit
                        </Button>*/}
                        <Button
                          className="btn btncreate"
                          color="secondary"
                          onClick={() => this.handleClose("emailModal")}
                        >
                          Close
                        </Button>
                      </DialogActions>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <DialogContent
                        id="classic-modal-slide-description"
                        className={classes.modalBody}
                      >
                        <div>
                          Your request has been sent to your <br /> account,
                          manager who will be in touch <br /> with you shortly.
                        </div>
                      </DialogContent>
                      <DialogActions className={classes.modalFooter}>
                        <center>
                          <Button
                            className="btn btncreate"
                            color="secondary"
                            onClick={() => this.handleClose("emailModal")}
                          >
                            Close
                          </Button>
                        </center>
                      </DialogActions>
                    </React.Fragment>
                  )}
                </Dialog>
              </center>
              <center>
                <Dialog
                  classes={{
                    root: classes.center + " " + classes.modalRoot,
                    paper: classes.modal,
                  }}
                  open={this.state.deploymentModal}
                  TransitionComponent={Transition}
                  disableBackdropClick
                  disableEscapeKeyDown
                  onClose={() => {
                    this.setState({ deploymentName: "" });
                    this.setState({ selectedChannel: "" });
                    this.setState({ selectedChannelType: "" });
                    this.setState({ automationTimestamp: 0 });
                    this.setState({ automationSwitchStatus: true });
                    this.setState({ selectedCampaign: "" });
                    this.setState({ selectedTypeInputfields: [] });
                    this.setState({ deploymentModal: false });
                  }}
                  aria-labelledby="classic-modal-slide-title"
                  aria-describedby="classic-modal-slide-description"
                >
                  <DialogTitle
                    id="classic-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                    style={{
                      backgroundColor: "#92B54B",
                      borderTopLeftRadius: "6px",
                      borderTopRightRadius: "6px",
                      width: "800px",
                    }}
                  >
                    <h4
                      className={classes.modalTitle}
                      style={{ color: "#fff" }}
                    >
                      <b> Automation</b>
                    </h4>
                  </DialogTitle>
                  {this.state.automationConfirmationModal == false ? (
                    <React.Fragment>
                      <DialogContent
                        id="classic-modal-slide-description"
                        className={classes.modalBody}
                      >
                        <div>
                          <GridContainer>
                            <GridItem xs={12} sm={12} md={12}>
                              <h4>Audience Name </h4>
                              <Select
                                isDisabled={true}
                                //onChange={this.handleChannelChange}
                                value={{
                                  value: this.state.audienceId,
                                  label: this.state.audienceTitle,
                                }}
                                options={[]}
                              />
                              <br />
                              <CustomInput
                                labelText="Automation Name"
                                id="deploymentName"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  onChange: (event) =>
                                    this.handleModalInput(
                                      event,
                                      "deploymentName"
                                    ),
                                }}
                              />
                              <span className="redColor">
                                {this.state.errors["deploymentName"]}
                              </span>
                              <h4>Program</h4>
                              <Select
                                // value="CSV"
                                onChange={this.handleChannelChange}
                                // options={this.state.automationDropSelection}
                                options={
                                  this.state.automationDropSelectionModified
                                }
                                styles={{
                                  // Fixes the overlapping problem of the component
                                  menu: (provided) => ({
                                    ...provided,
                                    zIndex: 9999,
                                  }),
                                }}
                              />
                              <span
                                style={{ color: "red", textAlign: "center" }}
                                className={
                                  this.state.error ? "block" : "hidden"
                                }
                              >
                                Please select a program
                              </span>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={12}>
                              <h4>Channel</h4>
                              <Select
                                // value="CSV"
                                onChange={this.handleChannelTypeChange}
                                options={this.state.channelTypesDropSelection}
                                styles={{
                                  // Fixes the overlapping problem of the component
                                  menu: (provided) => ({
                                    ...provided,
                                    zIndex: 9999,
                                  }),
                                }}
                              />
                              <span
                                style={{ color: "red", textAlign: "center" }}
                                className={
                                  this.state.channeltypeerror
                                    ? "block"
                                    : "hidden"
                                }
                              >
                                Please select a channel
                              </span>
                            </GridItem>
                            {this.state.localStorageClientId ===
                              "ccbdbd3c-f00d-477b-8f8e-7b0b10ae91f9" && (
                              <GridItem xs={12} sm={12} md={12}>
                                <h4>Friendly From</h4>
                                <Select
                                  onChange={
                                    this.handleFriendlyFromSelectionChange
                                  }
                                  options={
                                    this.state.friendlyFromDropdownSelection
                                  }
                                  styles={{
                                    // Fixes the overlapping problem of the component
                                    menu: (provided) => ({
                                      ...provided,
                                      zIndex: 9999,
                                    }),
                                  }}
                                />
                                <span
                                  style={{ color: "red", textAlign: "center" }}
                                  className={
                                    this.state.friendlyFromOptionError
                                      ? "block"
                                      : "hidden"
                                  }
                                >
                                  Please select a friendly from option
                                </span>
                              </GridItem>
                            )}
                            {this.state.localStorageClientId ===
                              "2bdbd6af-6cd3-4358-a1a0-437226a20ee9" && (
                              <GridItem xs={12} sm={12} md={12}>
                                <Button
                                  color="secondary"
                                  onClick={() =>
                                    this.setState({
                                      offerCodeModal: true,
                                      offerCodeValue: "",
                                      offerCodeDurationValue: "",
                                    })
                                  }
                                >
                                  Offer Code
                                </Button>
                              </GridItem>
                            )}
                            <GridItem
                              style={{ marginLeft: "5em", marginRight: "5em" }}
                              xs={12}
                              sm={12}
                              md={12}
                            >
                              <div
                                style={{
                                  paddingLeft: "5em",
                                  paddingRight: "5em",
                                }}
                              >
                                {this.state.selectedTypeInputfields.map(
                                  (stif, idx) =>
                                    stif.type == "string" ? (
                                      <CustomInput
                                        labelText={stif.labelName}
                                        id={stif.fieldName}
                                        formControlProps={{
                                          fullWidth: true,
                                        }}
                                        inputProps={{
                                          onChange: (event) =>
                                            this.handleselectedTypeInputfields(
                                              event,
                                              stif.fieldName
                                            ),
                                        }}
                                      />
                                    ) : (
                                      <Select
                                        // value="CSV"
                                        onChange={(event) =>
                                          this.handleTemplateChanges(
                                            event,
                                            stif.fieldName
                                          )
                                        }
                                        options={this.state.allTemplates}
                                        styles={{
                                          // Fixes the overlapping problem of the component
                                          menu: (provided) => ({
                                            ...provided,
                                            zIndex: 9999,
                                          }),
                                        }}
                                      />
                                    )
                                )}
                                <span
                                  style={{ color: "red", textAlign: "center" }}
                                  className={
                                    this.state.exInputFieldserror
                                      ? "block"
                                      : "hidden"
                                  }
                                >
                                  Please fill all fields
                                </span>
                                <center>
                                  <Dialog
                                    classes={{
                                      root:
                                        classes.center +
                                        " " +
                                        classes.modalRoot,
                                      paper: classes.modal,
                                    }}
                                    open={this.state.offerCodeModal}
                                    TransitionComponent={Transition}
                                    //keepMounted
                                    disableBackdropClick
                                    disableEscapeKeyDown
                                    onClose={() =>
                                      this.handleClose("offerCodeModal")
                                    }
                                    aria-labelledby="classic-modal-slide-title"
                                    aria-describedby="classic-modal-slide-description"
                                  >
                                    <DialogTitle
                                      id="classic-modal-slide-title"
                                      disableTypography
                                      className={classes.modalHeader}
                                      style={{
                                        backgroundColor: "#92B54B",
                                        borderTopLeftRadius: "6px",
                                        borderTopRightRadius: "6px",
                                        width: "500px",
                                      }}
                                    >
                                      <h4
                                        className={classes.modalTitle}
                                        style={{ color: "#fff" }}
                                      >
                                        <b> Offer Code</b>
                                      </h4>
                                    </DialogTitle>
                                    <DialogContent
                                      id="classic-modal-slide-description"
                                      className={classes.modalBody}
                                    >
                                      <div>
                                        <GridContainer>
                                          <GridItem xs={12} sm={12} md={12}>
                                            {this.state.localStorageClientId ===
                                              "2bdbd6af-6cd3-4358-a1a0-437226a20ee9" && (
                                              <div>
                                                <CustomInput
                                                  labelText="Offer Code"
                                                  id="offerCodeValue"
                                                  // formControlProps={{
                                                  //   fullWidth: true,
                                                  // }}
                                                  // value={
                                                  //   this.state.offerCodeValue
                                                  // }
                                                  inputProps={{
                                                    onChange: (event) =>
                                                      this.handleOfferCodeChange(
                                                        event
                                                      ),
                                                  }}
                                                />

                                                <br />
                                                <span className="redColor">
                                                  {
                                                    this.state.errors[
                                                      "offerCodeValue"
                                                    ]
                                                  }
                                                </span>
                                              </div>
                                            )}

                                            <div
                                              style={{ paddingLeft: "25px" }}
                                            >
                                              <CustomInput
                                                labelText="Duration"
                                                id="offerCodeDurationValue"
                                                // formControlProps={{
                                                //   fullWidth: true,
                                                // }}
                                                inputProps={{
                                                  onChange: (event) =>
                                                    this.handleDurationChange(
                                                      event
                                                    ),
                                                  style: {
                                                    width: "90%",
                                                  },
                                                }}
                                              />
                                              <span>days</span>
                                            </div>
                                            {/* <br /> */}
                                            <span className="redColor">
                                              {
                                                this.state.errors[
                                                  "offerCodeDurationValue"
                                                ]
                                              }
                                            </span>

                                            <br />
                                          </GridItem>
                                        </GridContainer>
                                      </div>
                                    </DialogContent>
                                    <DialogActions
                                      className={classes.modalFooter}
                                    >
                                      <Button
                                        onClick={() =>
                                          this.setState({
                                            offerCodeModal: false,
                                            offerCodeValue: "",
                                            offerCodeDurationValue: "",
                                          })
                                        }
                                        className="btn btncreate"
                                        color="secondary"
                                      >
                                        Cancel
                                      </Button>
                                      <Button
                                        className="btn btncreate"
                                        color="secondary"
                                        onClick={() => {
                                          this.offerCodeModalSaveButton();
                                        }}
                                      >
                                        Save
                                      </Button>
                                    </DialogActions>
                                  </Dialog>
                                </center>
                                <br />
                                <br />
                                <form
                                  className={classes.container}
                                  style={{
                                    textAlign: "left",
                                    display: "inline-block",
                                    marginRight: "50px",
                                  }}
                                  noValidate
                                >
                                  <TextField
                                    isValidDate={dateValid}
                                    id="datetime-local"
                                    label="Action date"
                                    type="datetime-local"
                                    //defaultValue="2017-05-24T10:30"
                                    className={classes.textField}
                                    InputLabelProps={{
                                      shrink: true,
                                    }}
                                    onChange={this.deploymentDate.bind(this)}
                                  />
                                </form>
                                <FormControlLabel
                                  control={
                                    <Switch
                                      color="primary"
                                      checked={
                                        this.state.automationSwitchStatus
                                      }
                                      onChange={(event) =>
                                        this.SwitchStatus(event.target.checked)
                                      }
                                    />
                                  }
                                  label="Status"
                                />
                                <FormControlLabel
                                  control={
                                    <Switch
                                      color="primary"
                                      checked={this.state.recurring}
                                      onChange={(event) =>
                                        this.RecurringToggleChange(
                                          event.target.checked
                                        )
                                      }
                                    />
                                  }
                                  label="Recurring"
                                />
                                <br />
                                <span className="redColor">
                                  {this.state.errors["automationtimestamp"]}
                                </span>
                                <br />
                                {this.state.recurring ? (
                                  <CronBuilder
                                    cronExpression="0 6 * * *"
                                    onChange={this.handleCronChange}
                                    showResult={true}
                                    style={{ backgroundColor: "#ffffff" }}
                                  />
                                ) : (
                                  ""
                                )}
                                <FormControlLabel
                                  control={
                                    <Switch
                                      color="primary"
                                      checked={
                                        this.state.clientSeedListSwitchStatus
                                      }
                                      onChange={(event) =>
                                        this.switchClientSeedListStatus(
                                          event.target.checked
                                        )
                                      }
                                    />
                                  }
                                  label="Include Client Seed List"
                                  style={{
                                    display: this.state
                                      .showOrHideClientSeedListSwitch,
                                  }}
                                />
                                <br />
                                <h4>Campaign</h4>
                                <Select
                                  // value="CSV"
                                  onChange={this.handlecampaignChange}
                                  options={this.state.campaignDropdown}
                                />
                                <Button
                                  onClick={() =>
                                    this.setState({
                                      campaignModal: true,
                                      preclubFlag: false,
                                    })
                                  }
                                  className="btn btncreate"
                                  color="secondary"
                                >
                                  Create Campaign
                                </Button>
                                <span
                                  style={{ color: "red", textAlign: "center" }}
                                  className={
                                    this.state.campaignerror
                                      ? "block"
                                      : "hidden"
                                  }
                                >
                                  Please Select a campaign
                                </span>
                              </div>
                            </GridItem>
                            {spendgoOffercode(this.state.localStorageClientId, this.state.selectedChannel) && (
                            <GridItem
                              xs={12}
                              sm={12}
                              md={12}
                            >
                              <CustomInput
                                labelText="SpendGo Campaign ID"
                                id="offerCodeValue"
                                inputProps={{
                                  value: this.state.offerCodeValue,
                                  onChange: (event) =>
                                    this.handleOfferCodeChange(
                                      event
                                    ),
                                }}
                              />
                              <br />
                              <span className="redColor">
                                {
                                  this.state.errors[
                                  "offerCodeValue"
                                  ]
                                }
                              </span>
                            </GridItem>
                          )}
                          </GridContainer>
                        </div>
                      </DialogContent>
                      <DialogActions className={classes.modalFooter}>
                        <Button
                          onClick={() => this.handleClose("deploymentModal")}
                          className="btn btncreate"
                          color="secondary"
                        >
                          Cancel
                        </Button>
                        <Button
                          className="btn btncreate"
                          color="secondary"
                          onClick={() => {
                            this.setState({ exportDisable: true });
                            this.exportAutomation();
                          }}
                          disabled={this.state.exportDisable}
                        >
                          Save
                        </Button>
                      </DialogActions>
                    </React.Fragment>
                  ) : (
                    <React.Fragment>
                      <DialogContent
                        id="classic-modal-slide-description"
                        className={classes.modalBody}
                      >
                        <div>
                          Your automation is being created.
                          <br />
                          Go to <a href="/automations">Automations</a>.
                        </div>
                      </DialogContent>

                      <DialogActions className={classes.modalFooter}>
                        <Button
                          className="btn btncreate"
                          color="secondary"
                          onClick={() => this.handleClose("deploymentModal")}
                        >
                          Close
                        </Button>
                      </DialogActions>
                    </React.Fragment>
                  )}
                </Dialog>
              </center>
              <center>
                <Dialog
                  classes={{
                    root: classes.center + " " + classes.modalRoot,
                    paper: classes.modal,
                  }}
                  open={this.state.campaignModal}
                  TransitionComponent={Transition}
                  //keepMounted
                  disableBackdropClick
                  disableEscapeKeyDown
                  onClose={() => this.handleClose("campaignModal")}
                  aria-labelledby="classic-modal-slide-title"
                  aria-describedby="classic-modal-slide-description"
                >
                  <DialogTitle
                    id="classic-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                    style={{
                      backgroundColor: "#92B54B",
                      borderTopLeftRadius: "6px",
                      borderTopRightRadius: "6px",
                      width: "800px",
                    }}
                  >
                    <h4
                      className={classes.modalTitle}
                      style={{ color: "#fff" }}
                    >
                      <b> Create Campaign</b>
                    </h4>
                  </DialogTitle>
                  <DialogContent
                    id="classic-modal-slide-description"
                    className={classes.modalBody}
                  >
                    <div>
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                          <CustomInput
                            labelText="Campaign Name"
                            id="campaignName"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              onChange: (event) =>
                                this.handleModalInput(event, "campaignName"),
                            }}
                          />
                          <span className="redColor">
                            {this.state.errors["campaignName"]}
                          </span>
                          <br />
                          <CustomInput
                            labelText="Campaign Description"
                            id="campaignDescription"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              onChange: (event) =>
                                this.handleModalInput(
                                  event,
                                  "campaignDescription"
                                ),
                            }}
                          />
                          <span className="redColor">
                            {this.state.errors["campaignDescription"]}
                          </span>
                          <br />
                          <FormControlLabel
                            control={
                              <Switch
                                color="primary"
                                checked={this.state.preclubFlag}
                                onChange={(event) =>
                                  this.togglePreclubFlagStatus(
                                    event.target.checked
                                  )
                                }
                              />
                            }
                            label="Guest Connect"
                          />
                          <br />
                          <form className={classes.container} noValidate>
                            <TextField
                              isValidDate={dateValid}
                              id="datetime-local"
                              label="Start Date"
                              type="datetime-local"
                              //defaultValue="2017-05-24T10:30"
                              className={classes.textField}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onChange={this.campaignStartDate.bind(this)}
                            />
                          </form>
                          <span className="redColor">
                            {this.state.errors["campaignStartDate"]}
                          </span>
                          <br />
                          <form className={classes.container} noValidate>
                            <TextField
                              isValidDate={dateValid}
                              id="datetime-local"
                              label="End Date"
                              type="datetime-local"
                              //defaultValue="2017-05-24T10:30"
                              className={classes.textField}
                              InputLabelProps={{
                                shrink: true,
                              }}
                              onChange={this.campaignEndDate.bind(this)}
                            />
                          </form>
                          <span className="redColor">
                            {this.state.errors["campaignEndDate"]}
                          </span>
                          <br />
                        </GridItem>
                      </GridContainer>
                    </div>
                  </DialogContent>
                  <DialogActions className={classes.modalFooter}>
                    <Button
                      onClick={() => this.setState({ campaignModal: false })}
                      className="btn btncreate"
                      color="secondary"
                    >
                      Cancel
                    </Button>
                    <Button
                      className="btn btncreate"
                      color="secondary"
                      onClick={() => {
                        this.saveCampaign();
                      }}
                    >
                      Save
                    </Button>
                  </DialogActions>
                </Dialog>
              </center>
              <center>
                <Dialog
                  classes={{
                    root: classes.center + " " + classes.modalRoot,
                    paper: classes.modal,
                  }}
                  open={this.state.copyAudienceModal}
                  TransitionComponent={Transition}
                  keepMounted
                  disableBackdropClick
                  disableEscapeKeyDown
                  onClose={() => this.setState({ copyAudienceModal: false })}
                  aria-labelledby="classic-modal-slide-title"
                  aria-describedby="classic-modal-slide-description"
                >
                  <DialogTitle
                    id="classic-modal-slide-title"
                    disableTypography
                    className={classes.modalHeader}
                    style={{
                      backgroundColor: "#92B54B",
                      borderTopLeftRadius: "6px",
                      borderTopRightRadius: "6px",
                      width: "800px",
                    }}
                  >
                    <h4
                      className={classes.modalTitle}
                      style={{ color: "#fff" }}
                    >
                      <b> Copy Audience </b>
                    </h4>
                  </DialogTitle>
                  <DialogContent
                    id="classic-modal-slide-description"
                    className={classes.modalBody}
                  >
                    <div>
                      <GridContainer>
                        <GridItem xs={12} sm={12} md={12}>
                          <CustomInput
                            labelText="Title"
                            id="copyTitle"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              onChange: (event) =>
                                this.handleChangeInput(event, "copyTitle"),
                              value: this.state.copyTitle,
                            }}
                          />
                          <span className="redColor">
                            {this.state.errors["copyTitle"]}
                          </span>
                          <br />
                          <CustomInput
                            labelText="Description"
                            id="copyDescription"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              onChange: (event) =>
                                this.handleChangeInput(
                                  event,
                                  "copyDescription"
                                ),
                              value: this.state.copyDescription,
                            }}
                          />
                          <span className="redColor">
                            {this.state.errors["copyDescription"]}
                          </span>
                        </GridItem>
                      </GridContainer>
                    </div>
                  </DialogContent>
                  <DialogActions className={classes.modalFooter}>
                    <Button
                      onClick={() =>
                        this.setState({ copyAudienceModal: false })
                      }
                      className="btn btncreate"
                      color="secondary"
                    >
                      Cancel
                    </Button>
                    <Button
                      className="btn btncreate"
                      color="secondary"
                      onClick={() => {
                        this.saveCopyAudience();
                      }}
                    >
                      Save
                    </Button>
                  </DialogActions>
                </Dialog>
              </center>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
Audience.propTypes = {
  classes: PropTypes.object.isRequired,
};
export default withStyles(notificationsStyle)(Audience);



// WEBPACK FOOTER //
// ./src/views/Audiences/ViewAudiences.jsx